import {
  Avatar,
  Badge,
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  Modal,
  MultiSelect,
  NumberFormatter,
  NumberInput,
  Popover,
  Select,
  Table,
  Text,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconCheck,
  IconClock,
  IconCopy,
  IconInfoCircle,
  IconTruck,
  IconWindow,
} from "@tabler/icons-react";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { getAhamoveEstimates, getGrabExpressQuotes } from "../../../../api/apiDeliveryPartner";
import { sky_blue } from "../../../../const/variables";
import { ComboboxItem } from "../../../../model/ComboboxItem";
import { MessageResponse } from "../../../../model/MessageResponse";
import { TblDeliveryInformation } from "../../../../model/TblDmDelivery";
import { getProvinceSelectNew } from "../../../../service/getSelectApi";
import {
  checkProductSpecifications,
  SpecificationsCheckResult,
} from "../../../../service/productSpecificationsService";

import { calculateDistanceMatrix } from "../../../../helpers/vietMapHelper";
import { GHTK_CONFIG } from "./constants/apiConfig";
import {
  DEFAULT_SHIPPING_PARTNERS,
  SHIPPING_TYPE_OPTIONS,
} from "./constants/shippingPartnersData";
import { WAREHOUSE_DATA, WarehouseInfo } from "./constants/warehouseData";
import "./styles/modalDeliveryInformation.css";

import {
  handleCopyAddress as helperCopyAddress,
  handleCopyCustomerInfo as helperCopyCustomerInfo,
} from "./helpers/deliveryHelpers";
import { ShippingPartner } from "./types/modalDeliveryTypes";
import { apiAuth } from "../../../../api/apiAuth";

const INTERNAL_PARTNER_NAMES = [
  "NV điều vận",
  "Kỹ thuật",
  "Dự án",
  "Kỹ thuật thi công",
  "COD",
];

const normalizeVietnameseText = (value: string): string =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .replace(/\s*-\s*/g, "-")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

const GHTK_EXPRESS_WARDS_HANOI = new Set(
  [
    "Phường Tây Tựu",
    "Phường Hà Đông",
    "Phường Long Biên",
    "Phường Hoàng Mai",
    "Phường Bồ Đề",
    "Phường Đại Mỗ",
    "Phường Yên Sở",
    "Phường Việt Hưng",
    "Phường Tây Mỗ",
    "Phường Từ Liêm",
    "Phường Hoàng Liệt",
    "Phường Tương Mai",
    "Phường Đông Ngạc",
    "Phường Lĩnh Nam",
    "Phường Vĩnh Hưng",
    "Phường Xuân Phương",
    "Phường Phú Lương",
    "Phường Dương Nội",
    "Phường Phúc Lợi",
    "Phường Định Công",
    "Phường Yên Nghĩa",
    "Phường Kiến Hưng",
    "Phường Xuân Đỉnh",
    "Phường Thượng Cát",
    "Phường Phú Diễn",
    "Phường Thanh Liệt",
    "Phường Hồng Hà",
    "Phường Hoàn Kiếm",
    "Phường Nghĩa Đô",
    "Phường Ngọc Hà",
    "Phường Khương Đình",
    "Phường Yên Hòa",
    "Phường Bạch Mai",
    "Phường Thanh Xuân",
    "Phường Giảng Võ",
    "Phường Cửa Nam",
    "Phường Hai Bà Trưng",
    "Phường Vĩnh Tuy",
    "Phường Ô Chợ Dừa",
    "Phường Kim Liên",
    "Phường Láng",
    "Phường Cầu Giấy",
    "Phường Phương Liệt",
    "Phường Tây Hồ",
    "Phường Văn Miếu - Quốc Tử Giám",
    "Phường Đống Đa",
    "Phường Phú Thượng",
    "Phường Ba Đình",
  ].map(normalizeVietnameseText)
);

const ModalDeliveryInformation = ({
  customerCheck,
  dataDeliveryInformation,
  setDataDeliveryInformation,
  setShippingVendor,
  shipping,
  shipingVendor,
  readOnly,
  cod,
  branchId,
  attribute36,
  listAddress,
  listAdd,
  payType,
  setIsHaveShipping,
  isHaveVat,
  setOrderHeader,
  orderHeader,
  technicalRequired = 0,
}: {
  dataDeliveryInformation: any;
  setDataDeliveryInformation: React.Dispatch<React.SetStateAction<any>>;
  setShippingVendor: React.Dispatch<React.SetStateAction<string>>;
  setIsHaveShipping?: React.Dispatch<React.SetStateAction<boolean>>;
  customerCheck?: any;
  shipping?: string;
  shipingVendor?: string;
  shipper?: string;
  readOnly?: boolean;
  cod?: number;
  branchId?: number;
  attribute36?: string;
  listAddress?: any[];
  listAdd?: any;
  payType?: string;
  isHaveVat?: boolean;
  setOrderHeader?: React.Dispatch<React.SetStateAction<any>>;
  orderHeader?: any;
  technicalRequired?: number;
}) => {
  const [visible] = useDisclosure(false);
  const [dataItemNote, setDataItemNote] = useState<ComboboxItem[]>([]);
  const [dataTblProvinceSelect, setDataTblProvinceSelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataTblCommuneSelect, setDataTblCommuneSelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataStation, setDataStation] = useState<any[]>([]);
  const [calculatedDistance, setCalculatedDistance] = useState<number | null>(
    null
  );
  const [cachedDistanceKm, setCachedDistanceKm] = useState<number | null>(null); // ⭐ Cache khoảng cách để tái sử dụng
  const [branchName, setBranchName] = useState<string | null>(null);
  const [openShippingPartnerModal, setOpenShippingPartnerModal] =
    useState(false);
  const [specificationsResult, setSpecificationsResult] =
    useState<SpecificationsCheckResult | null>(null);
  const [conditionsPopupOpened, setConditionsPopupOpened] = useState(false);
  const [timeFilter, setTimeFilter] = useState<string | null>(null);
  const [shippingPartners, setShippingPartners] = useState<ShippingPartner[]>(
    DEFAULT_SHIPPING_PARTNERS
  );

  const [isLoadingGHtkFee, setIsLoadingGHtkFee] = useState(false);
  const [isLoadingAhamoveFee, setIsLoadingAhamoveFee] = useState(false);
  const [isLoadingGrabFee, setIsLoadingGrabFee] = useState(false);
  const [isPreparingShippingFee, setIsPreparingShippingFee] = useState(false);

  // ⭐ Local state cho display value của phí ship
  // Init với 0, sẽ được sync bởi useEffect khi dataDeliveryInformation thay đổi
  const [displayDeliveryFee, setDisplayDeliveryFee] = useState<number>(0);

  const [userAuthType, setUserAuthType] = useState<number | null>(null);

  // ⭐ State cho giao hàng văn phòng 124
  const [isOffice124, setIsOffice124] = useState<boolean>(
    Boolean(dataDeliveryInformation?.isOffice124)
  );
  const [senderPhone, setSenderPhone] = useState<string>(
    dataDeliveryInformation?.senderPhone ||
      dataDeliveryInformation?.pick_tel ||
      ""
  );
  const [senderPhoneError, setSenderPhoneError] = useState<string>("");

  useEffect(() => {
    if (dataDeliveryInformation?.isOffice124 !== undefined) {
      setIsOffice124(Boolean(dataDeliveryInformation.isOffice124));
    }
    if (
      dataDeliveryInformation?.senderPhone ||
      dataDeliveryInformation?.pick_tel
    ) {
      setSenderPhone(
        dataDeliveryInformation.senderPhone ||
          dataDeliveryInformation.pick_tel ||
          ""
      );
    }
  }, [dataDeliveryInformation]);

  useEffect(() => {
    const fetchUserAuth = async () => {
      try {
        const authData = await apiAuth.getUserAuth();
        if (authData?.data?.typeAtuh !== undefined) {
          setUserAuthType(Number(authData.data.typeAtuh));
        }
      } catch (error) {
        console.error("Error fetching user auth:", error);
      }
    };
    fetchUserAuth();
  }, []);

  const isShippingFeeLoading =
    isPreparingShippingFee || isLoadingGHtkFee || isLoadingAhamoveFee || isLoadingGrabFee;
  const getLoadingSourceLabel = () => {
    const loadingSources = [];
    if (isLoadingGHtkFee) loadingSources.push("Giao hàng tiết kiệm");
    if (isLoadingAhamoveFee) loadingSources.push("Ahamove");
    if (isLoadingGrabFee) loadingSources.push("GrabExpress");
    return loadingSources.join(" và ") || "đơn vị vận chuyển";
  };
  const loadingSourceLabel = getLoadingSourceLabel();
  const loadingTitleText = isPreparingShippingFee
    ? "🔄 Đang chuẩn bị dữ liệu giao hàng"
    : "🔄 Đang tải phí vận chuyển";
  const loadingDetailText = isPreparingShippingFee
    ? "Đang đo khoảng cách và kiểm tra kích thước sản phẩm..."
    : `Từ ${loadingSourceLabel}`;

  const entity: TblDeliveryInformation = {
    deliveryFee: dataDeliveryInformation?.deliveryFee,
    // Business rule: Set COD to 0 if payment type is not COD
    cod: payType !== "Giao Hàng Thu Tiền(COD)" ? 0 : cod || 0,
    shippingVendor: shipingVendor || "",
    customerId: dataDeliveryInformation?.customerId
      ? dataDeliveryInformation?.customerId
      : customerCheck?.id,
    customerName: dataDeliveryInformation?.customerName
      ? dataDeliveryInformation?.customerName
      : customerCheck?.name,
    telephoneNumber: dataDeliveryInformation?.telephoneNumber
      ? dataDeliveryInformation?.telephoneNumber
      : customerCheck?.telephoneNumber,
    customerAddress: dataDeliveryInformation?.customerAddress
      ? dataDeliveryInformation?.customerAddress
      : customerCheck?.address,
    customerProvinceId: dataDeliveryInformation?.customerProvinceId
      ? dataDeliveryInformation?.customerProvinceId
      : customerCheck?.attribute13?.toString(), // attribute13 là ID tỉnh/thành phố
    customerDistrictId: null, // Không sử dụng district nữa trong form mới
    customerCommuneId: dataDeliveryInformation?.customerCommuneId
      ? dataDeliveryInformation?.customerCommuneId
      : customerCheck?.attribute14?.toString(), // attribute14 là ID phường/xã
    depId: dataDeliveryInformation?.depId,
    deliveryAppointmentTime:
      dataDeliveryInformation?.deliveryAppointmentTime || new Date(),

    description: dataDeliveryInformation?.description,
    typeShip: dataDeliveryInformation?.typeShip,
    timeDelivery: dataDeliveryInformation?.timeDelivery,
    timeDeliveryTime: dataDeliveryInformation?.timeDeliveryTime,
    sourceType: 1,
    sourceCode: dataDeliveryInformation?.sourceCode,
    status: dataDeliveryInformation?.status,
    communeName: dataDeliveryInformation?.roadId,
    weight: dataDeliveryInformation?.weight,
    width: dataDeliveryInformation?.width,
    length: dataDeliveryInformation?.length,
    height: dataDeliveryInformation?.height,
    feeShip: dataDeliveryInformation?.feeShip,
    to_address: dataDeliveryInformation?.to_address,
    to_address_id: dataDeliveryInformation?.to_address_id,
    distance: dataDeliveryInformation?.distance,
    transportName: dataDeliveryInformation?.transportName,
    itemNotes: dataDeliveryInformation?.itemNotes,
    itemNotesName: dataDeliveryInformation?.itemNotesName,
  };

  // Ưu tiên dữ liệu đã lưu trong dataDeliveryInformation
  // Chỉ sử dụng attribute36 nếu chưa có dữ liệu đã lưu
  let receiverName = entity.customerName;
  let receiverPhone = entity.telephoneNumber;

  // Nếu đã có dữ liệu lưu trong dataDeliveryInformation, sử dụng nó
  if (dataDeliveryInformation?.customerName) {
    receiverName = dataDeliveryInformation.customerName;
  } else if (
    attribute36 &&
    typeof attribute36 === "string" &&
    attribute36.includes("-")
  ) {
    // Chỉ parse attribute36 nếu chưa có dữ liệu đã lưu
    const [name, phone] = attribute36.split("-").map((s) => s.trim());
    if (name) receiverName = name;
    if (phone) receiverPhone = phone;
  }

  if (dataDeliveryInformation?.telephoneNumber) {
    receiverPhone = dataDeliveryInformation.telephoneNumber;
  } else if (
    attribute36 &&
    typeof attribute36 === "string" &&
    attribute36.includes("-") &&
    !dataDeliveryInformation?.customerName
  ) {
    const [, phone] = attribute36.split("-").map((s) => s.trim());
    if (phone) receiverPhone = phone;
  }

  const entityOverride = {
    ...entity,
    customerName: receiverName,
    telephoneNumber: receiverPhone,
  };

  const form = useForm<TblDeliveryInformation>({
    validateInputOnChange: true,
    initialValues: {
      ...entityOverride,
    },

    validate: {
      customerName: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên người nhận !";
        }
        if (value.length > 255) {
          return "Tên người nhận không được dài hơn 255 ký tự !";
        }
        return null;
      },
      telephoneNumber: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập số điện thoại!";
        }
        if (value.length > 11) {
          return "SĐT dài hơn 11 ký tự !";
        }
        return null;
      },
      customerProvinceId: (value: string | number | null) => {
        if (!value) return "Vui lòng chọn tỉnh/thành phố!";
        // Kiểm tra có trong danh sách không
        const found = dataTblProvinceSelect.some(
          (item) => item.value?.toString() === value?.toString()
        );
        if (!found) return "Tỉnh/thành phố không hợp lệ!";
        return null;
      },
      customerCommuneId: (value: string | number | null) => {
        if (!value) return "Vui lòng chọn phường/xã!";
        // Kiểm tra có trong danh sách không
        const found = dataTblCommuneSelect.some(
          (item) => item.value?.toString() === value?.toString()
        );
        if (!found) return "Phường/xã không hợp lệ!";
        return null;
      },
      customerAddress: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập địa chỉ cụ thể !";
        }
      },
      deliveryAppointmentTime: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập thời gian giao hàng !";
        }
      },
      typeShip: (value: string | null | undefined) => {
        if (!value || !value.trim()) {
          return "Vui lòng chọn phương thức giao hàng!";
        }
        return null;
      },
      shippingVendor: (value: string | null | undefined) => {
        if (!value || !value.trim()) {
          return "Vui lòng chọn đơn vị vận chuyển!";
        }
        return null;
      },
      timeDeliveryTime: (value: string | null | undefined) => {
        if (!value) {
          return "Vui lòng nhập thời gian giao hàng cụ thể!";
        }
        // Kiểm tra định dạng HH:MM
        const regex = /^([01]\d|2[0-3]):([0-5]\d)$/;
        if (!regex.test(value)) {
          return "Định dạng giờ không hợp lệ. Vui lòng nhập theo dạng HH:MM!";
        }
        return null;
      },
    },
  });

  const handleKeyDown = (event: any) => {
    if (event.key === "-") {
      event.preventDefault();
    }
  };



  const resetShippingSelection = useCallback(() => {
    form.setFieldValue("shippingVendor", "");
    form.setFieldValue("typeShip", "");
    form.setFieldValue("deliveryFee", "0");
    form.setFieldValue("timeDelivery", "");
    form.setFieldValue("timeDeliveryTime", "");

    setDisplayDeliveryFee(0);
    setShippingVendor("");
    setShippingPartners(DEFAULT_SHIPPING_PARTNERS);
    setCalculatedDistance(null);
    setCachedDistanceKm(null);

    setDataDeliveryInformation((prev: any) => ({
      ...prev,
      shippingVendor: "",
      typeShip: "",
      deliveryFee: 0,
      timeDelivery: "",
      timeDeliveryTime: "",
    }));

    if (setOrderHeader) {
      setOrderHeader((prevOrderHeader: any) => ({
        ...prevOrderHeader,
        attribute3: 0,
      }));
    }
  }, [
    form,
    setCalculatedDistance,
    setCachedDistanceKm,
    setDataDeliveryInformation,
    setDisplayDeliveryFee,
    setOrderHeader,
    setShippingPartners,
    setShippingVendor,
  ]);

  const handleChangeSelectedProvince = (id: string | null) => {
    if (id) {
      const prevProvinceId = form.values.customerProvinceId?.toString() || "";
      if (prevProvinceId && prevProvinceId !== id) {
        resetShippingSelection();
      }

      form.getInputProps("customerProvinceId").onChange(id);
      form.getInputProps("customerCommuneId").onChange(null);
      form.getInputProps("roadId").onChange(null);
    }
  };

  const handleChangeSelectedCommune = (id: string | null) => {
    if (id) {
      form.getInputProps("customerCommuneId").onChange(id);
      form.getInputProps("roadId").onChange(null);
    }
  };

  const handleChangeStation = (selectedId: any) => {
    if (!selectedId) {
      form.getInputProps("distance").onChange(0);
      form.getInputProps("to_address_id").onChange(null);
      return;
    }

    const selectedTransport = dataStation.find(
      (item) => item.value === selectedId
    );

    if (selectedTransport) {
      form.getInputProps("distance").onChange(selectedTransport.distance || 0);
      form.getInputProps("to_address_id").onChange(selectedTransport.value);
    }
  };

  const handleCopyAddress = async () => {
    await helperCopyAddress(
      form.values.customerAddress || "",
      form.values.customerProvinceId?.toString() || "",
      form.values.customerCommuneId?.toString() || ""
    );
  };

  const handleCopyCustomerInfo = async () => {
    await helperCopyCustomerInfo(
      form.values.customerName || "",
      form.values.telephoneNumber || ""
    );
  };

  // ⭐ HELPER: Kiểm tra tỉnh có phải Hà Nội hoặc HCM dựa trên tên
  // Tránh hardcoded ID để đảm bảo tương thích giữa dev và prod
  const isHanoiOrHCMProvince = useCallback(
    (provinceId: string): { isHanoi: boolean; isHCM: boolean } => {
      const province = dataTblProvinceSelect.find(
        (p) => p.value.toString() === provinceId
      );
      const provinceName = (province?.label || "").toLowerCase();

      const isHanoi =
        provinceName.includes("hà nội") || provinceName.includes("ha noi");
      const isHCM =
        provinceName.includes("hồ chí minh") ||
        provinceName.includes("ho chi minh") ||
        provinceName.includes("tp.hcm") ||
        provinceName.includes("tp hồ chí minh") ||
        provinceName.includes("tp ho chi minh") ||
        provinceName.includes("hcm");

      return { isHanoi, isHCM };
    },
    [dataTblProvinceSelect]
  );

  const selectedCommuneLabel = useMemo(() => {
    const selectedCommuneId = form.values.customerCommuneId?.toString();
    if (!selectedCommuneId) return "";

    const selectedCommune = dataTblCommuneSelect.find(
      (item) => item.value?.toString() === selectedCommuneId
    );
    return selectedCommune?.label || "";
  }, [dataTblCommuneSelect, form.values.customerCommuneId]);

  const isGhtkExpressType = useMemo(() => {
    const provinceId = form.values.customerProvinceId?.toString() || "";
    if (!provinceId || !selectedCommuneLabel) {
      return false;
    }

    const { isHanoi } = isHanoiOrHCMProvince(provinceId);
    if (!isHanoi) {
      return false;
    }

    return GHTK_EXPRESS_WARDS_HANOI.has(
      normalizeVietnameseText(selectedCommuneLabel)
    );
  }, [
    form.values.customerProvinceId,
    selectedCommuneLabel,
    isHanoiOrHCMProvince,
  ]);

  // ⭐ HELPER: Tính thời gian lắp đặt dựa vào technicalRequired
  // Trả về thời gian bổ sung (giờ) và text mô tả
  const getTechnicalInstallationTime = useCallback((): {
    hours: number;
    text: string;
  } => {
    switch (technicalRequired) {
      case 1: // Lắp ráp (mới)
        return { hours: 0.75, text: " (+45 phút lắp ráp)" }; // 45 phút
      case 2: // Kiểm tra mới
        return { hours: 0.5, text: " (+30 phút kiểm tra)" }; // 30 phút
      case 3: // Lắp ráp mới + Kiểm tra mới
        return { hours: 1, text: " (+1 giờ lắp ráp & kiểm tra)" }; // 60 phút
      default:
        return { hours: 0, text: "" }; // Không có yêu cầu dịch vụ
    }
  }, [technicalRequired]);

  // ⭐ HELPER: Format thời gian giao hàng bao gồm cả thời gian lắp đặt
  const formatEstimatedTime = useCallback(
    (baseHours: number): string => {
      const installTime = getTechnicalInstallationTime();
      const totalHours = baseHours + installTime.hours;

      if (totalHours < 1) {
        const minutes = Math.round(totalHours * 60);
        return `${minutes} phút${installTime.text}`;
      } else {
        // Tách giờ và phút
        const hours = Math.floor(totalHours);
        const minutes = Math.round((totalHours - hours) * 60);

        if (minutes === 0) {
          return `${hours} giờ${installTime.text}`;
        } else {
          return `${hours} giờ ${minutes} phút${installTime.text}`;
        }
      }
    },
    [getTechnicalInstallationTime]
  );

  // ⭐ TÍNH PHÍ HÀNG CỒNG KỀNH THEO BBS
  const calculateBulkyItemFee = useCallback((weightInKg: number): number => {
    const roundedWeight = Math.ceil(weightInKg); // Làm tròn lên
    if (roundedWeight < 10) return 0;
    if (roundedWeight <= 20) return 40000 + (roundedWeight - 10) * 4000;
    return 80000 + (roundedWeight - 20) * 4000;
  }, []);

  const calculateInternalDistanceFee = useCallback((km: number): number => {
    if (km <= 10) return 0;
    return (km - 10) * 3000;
  }, []);

  const calculateOrderValue = useCallback((): number => {
    if (!listAdd || listAdd.length === 0) return 0;
    return listAdd.reduce((total: number, item: any) => {
      const itemPrice = item.priceFinal || item.priceOnPriceList || 0;
      const itemQuality = item.quality || 1;
      return total + itemPrice * itemQuality;
    }, 0);
  }, [listAdd]);

  const isShippingFeeDisabled = useMemo(() => {
    // Nếu readOnly từ component cha = true -> luôn disabled
    if (readOnly) return true;
    
    // Nếu user có quyền mức 1 hoặc 2 -> được phép sửa
    if (userAuthType === 1 || userAuthType === 2) {
      return false; 
    }

    const orderValue =
      calculateOrderValue() ||
      Number(orderHeader?.amountTotal) ||
      Number(orderHeader?.totalAmount) ||
      0;
    return Boolean(orderValue > 0);
  }, [
    calculateOrderValue,
    orderHeader?.amountTotal,
    orderHeader?.totalAmount,
    readOnly,
    userAuthType,
  ]);

  const calculateInternalStandardFee = useCallback(
    (orderValue: number): number => {
      if (orderValue >= 300000) return 0;
      return 15000;
    },
    []
  );

  // ⭐ CENTRAL SHIPPING FEE CALCULATION - SINGLE SOURCE OF TRUTH
  const calculateShippingFeeBase = async (
    provinceId: string,
    communeId: string,
    shippingVendor: string
  ): Promise<number> => {
    try {
      // Tính tổng giá trị đơn hàng
      let orderValue = 0;
      if (listAdd && listAdd.length > 0) {
        orderValue = listAdd.reduce((total: number, item: any) => {
          const itemPrice = item.priceFinal || item.priceOnPriceList || 0;
          const itemQuality = item.quality || 1;
          return total + itemPrice * itemQuality;
        }, 0);
      }

      // ⭐ AHAMOVE - Lấy phí trực tiếp từ API, KHÔNG áp dụng giảm giá
      // Format: "Ahamove Siêu tốc" hoặc "Ahamove Siêu tốc tiết kiệm"
      if (shippingVendor.startsWith("Ahamove")) {
        const partner = shippingPartners.find((p) => {
          const vendorFullName = `${p.name} ${p.description}`;
          return vendorFullName === shippingVendor;
        });
        return partner?.fee || 0;
      }

      // ⭐ GRAB - Lấy phí trực tiếp từ API
      if (shippingVendor.startsWith("Grab")) {
        const partner = shippingPartners.find((p) => p.name === "Grab");
        return partner?.fee || 0;
      }

      // ⭐ GHTK - Lấy phí từ API, KHÔNG áp dụng giảm giá theo đơn hàng
      if (shippingVendor === "Giao hàng tiết kiệm") {
        const partner = shippingPartners.find((p) => p.name === shippingVendor);
        return partner?.fee || 0;
      }

      // ⭐ NỘI BỘ HACOM & COD - Logic mới: Đều là 15k (đơn < 300k) hoặc 0đ (đơn >= 300k)
      if (INTERNAL_PARTNER_NAMES.includes(shippingVendor) || shippingVendor === "COD" || shippingVendor === "Kho đóng gói") {
        let fee = orderValue >= 300000 ? 0 : 15000;
        // Nếu là hàng cồng kềnh, nội bộ Hacom sẽ lấy bằng phí GHTK
        if (specificationsResult?.hasOverSizeItems && INTERNAL_PARTNER_NAMES.includes(shippingVendor)) {
          const ghtkPartner = shippingPartners.find(p => p.name === "Giao hàng tiết kiệm");
          fee = ghtkPartner?.fee || fee;
        }
        return fee;
      }
      
      // Mặc định fallback
      return 0;
    } catch (error) {
      console.error("❌ Error calculating shipping fee:", error);
      return 0;
    }
  };

  // ⭐ WRAPPER: Tính phí ship + phí cồng kềnh
  const calculateShippingFee = async (
    provinceId: string,
    communeId: string,
    shippingVendor: string
  ): Promise<number> => {
    console.log("🔍 DEBUG - calculateShippingFee START:", {
      provinceId,
      communeId,
      shippingVendor,
      hasSpecsResult: !!specificationsResult,
      totalWeight: specificationsResult?.totalWeight,
    });

    // Tính phí ship cơ bản
    const baseFee = await calculateShippingFeeBase(
      provinceId,
      communeId,
      shippingVendor
    );

    console.log("🔍 DEBUG - Base fee calculated:", baseFee);

    // ⭐ Chính sách mới: Hủy miễn phí hoàn toàn cho nội thành.
    // Phí cồng kềnh vẫn sẽ được áp dụng cho toàn quốc.

    // Ngoại thành - Tính phí cồng kềnh chỉ cho các item có isCongKenh = true
    const totalWeight = specificationsResult?.totalWeight || 0;
    const bulkyWeight = specificationsResult?.hasOverSizeItems
      ? specificationsResult.overSizeItemsDetails.reduce(
          (sum: number, item: any) => sum + item.totalWeight,
          0
        )
      : 0;
    const bulkyFee = calculateBulkyItemFee(bulkyWeight);

    const totalFee = baseFee + bulkyFee;

    console.log("💰 FINAL FEE BREAKDOWN (outer city):", {
      shippingVendor,
      baseFee,
      bulkyFee,
      totalWeight,
      roundedWeight: Math.ceil(totalWeight),
      totalFee,
    });

    return totalFee;
  };

  const handleSaveForm = async (dataSubmit: any) => {
    console.log("🔥 handleSaveForm CALLED!", dataSubmit);
    try {
      const validateResult = form.validate();
      if (validateResult.hasErrors) {
        NotificationExtension.Fails(
          "Vui lòng nhập đầy đủ thông tin giao hàng bắt buộc trước khi lưu"
        );
        return;
      }

      if (isOffice124 && (!senderPhone || !senderPhone.trim())) {
        setSenderPhoneError("Vui lòng nhập số điện thoại người gửi!");
        NotificationExtension.Fails(
          "Vui lòng nhập số điện thoại người gửi đơn hàng cho văn phòng 124!"
        );
        return;
      }

      // ⭐ Đảm bảo specs được tính trước khi tính phí
      if (!specificationsResult) {
        const specsResult = await checkProductSpecifications(listAdd, cod);
        setSpecificationsResult(specsResult);
      }

      // ⭐ SỬ DỤNG PHÍ SHIP ĐÃ ĐƯỢC CHỌN/NHẬP (displayDeliveryFee)
      // KHÔNG tính lại để tránh ghi đè giá trị user đã chọn
      const shippingVendor = dataSubmit.shippingVendor || "";
      const provinceId = dataSubmit.customerProvinceId?.toString() || "";
      const communeId = dataSubmit.customerCommuneId?.toString() || "";

      // Sử dụng displayDeliveryFee thay vì tính lại
      const finalFee = displayDeliveryFee;

      console.log(" Using delivery fee:", {
        displayDeliveryFee,
        finalFee,
        shippingVendor,
        provinceId,
        communeId,
      });

      // Lưu thông tin giao hàng
      const updatedDeliveryInfo = {
        ...dataSubmit,
        customerId: customerCheck?.id,
        deliveryFee: finalFee, // ⭐ SỬ DỤNG PHÍ ĐÃ CHỌN
        isOffice124: isOffice124,
        senderPhone: isOffice124 ? senderPhone.trim() : undefined,
        pick_address: isOffice124
          ? "124 Minh Khai, Hai Bà Trưng, Hà Nội"
          : undefined,
        pick_tel: isOffice124 ? senderPhone.trim() : undefined,
        pick_province: isOffice124 ? "Hà Nội" : undefined,
        pick_district: isOffice124 ? "Hai Bà Trưng" : undefined,
        pick_ward: isOffice124 ? "Minh Khai" : undefined,
        fromAddress: isOffice124
          ? "124 Minh Khai, Hai Bà Trưng, Hà Nội"
          : branchName || undefined,
      };

      setDataDeliveryInformation(updatedDeliveryInfo);

      // Lưu phí ship vào attributeValue3 của orderHeader
      if (setOrderHeader) {
        setOrderHeader((prevOrderHeader: any) => ({
          ...prevOrderHeader,
          attributeValue3: finalFee,
          attribute1: JSON.stringify({
            ...updatedDeliveryInfo,
            branchId: branchId || prevOrderHeader?.branchId || null,
          }),
          shipngType: "Giao hàng",
        }));
      }

      if (setIsHaveShipping) {
        setIsHaveShipping(true);
      }
      modals.closeAll();
    } catch (error) {
      console.error("Error saving form:", error);
      NotificationExtension.Fails("Có lỗi khi lưu thông tin giao hàng");
    }
  };

  const fetchDataItemNote = async () => {
    const res = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmItemNote/get-list?Skip=0&Take=300",
    );

    if (res && res.success) {
      const data = res.data;
      setDataItemNote(
        data
          .filter((i: any) => i.id && i.name && i.status === "Y")
          .map((i: any) => ({
            label: String(i.name),
            value: String(i.id),
          })),
      );
    }
  };

  const fetchDataProvinceSelect = async () => {
    const getData = await getProvinceSelectNew();
    const filteredData = getData?.filter(
      (item: any) => item.id != null && item.name != null
    );
    const mappedData = filteredData?.map((item: any) => ({
      value: String(item.id),
      label: item.name,
    }));
    setDataTblProvinceSelect(mappedData);
  };

  const fetchDataCommuneSelect = useCallback(async () => {
    const provinceId = form.values.customerProvinceId?.toString() ?? "";
    if (!provinceId) {
      setDataTblCommuneSelect([]);
      return;
    }
    try {
      const response = await repositoryMdm.get(
        `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${provinceId}`
      );
      const getData = response?.data ?? [];
      const filteredData = getData?.filter(
        (item: any) => item.value != null && item.text != null
      );
      const mappedData = filteredData?.map((item: any) => ({
        value: item.value,
        label: item.text,
      }));
      setDataTblCommuneSelect(mappedData);
    } catch (error) {
      console.error("Error fetching commune data:", error);
      setDataTblCommuneSelect([]);
    }
  }, [form.values.customerProvinceId]);

  const fetchDataTransactionNumber = async () => {
    const url = `/api/v1/TblDelivery/create`;
    try {
      const getData = await repositoryDelivery.get<MessageResponse<any>>(url);
      if (getData?.data) {
      } else {
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDataProvinceSelect();
    fetchDataItemNote();
    fetchDataTransactionNumber();
  }, []);

  // ⭐ Sync display value khi data thay đổi từ bên ngoài
  useEffect(() => {
    const feeValue = dataDeliveryInformation?.deliveryFee;
    if (feeValue !== undefined && feeValue !== null) {
      setDisplayDeliveryFee(Number(feeValue));
    }
  }, [dataDeliveryInformation?.deliveryFee, dataDeliveryInformation]); // Watch both for safety

  useEffect(() => {
    if (form.values.customerProvinceId) {
      fetchDataCommuneSelect();
    }
  }, [form.values.customerProvinceId, customerCheck, fetchDataCommuneSelect]);

  // Update form khi customerCheck thay đổi và có attribute13/attribute14
  useEffect(() => {
    if (customerCheck && !dataDeliveryInformation) {
      // Chỉ update nếu chưa có dữ liệu đã lưu
      if (customerCheck.attribute13) {
        form.setFieldValue(
          "customerProvinceId",
          customerCheck.attribute13.toString()
        );
      }
      if (customerCheck.attribute14) {
        form.setFieldValue(
          "customerCommuneId",
          customerCheck.attribute14.toString()
        );
      }
    }
  }, [customerCheck, dataDeliveryInformation, form]);

  const createDataStationMap = (data: any) => {
    if (!Array.isArray(data)) return [];

    return data.map(({ transportAddress, ...rest }) => ({
      ...rest,
      to_address: transportAddress, // Đổi tên transportAddress thành to_address
    }));
  };

  useEffect(() => {
    const handleFetchStation = async () => {
      const url = `/api/v1/TblDmTransports/get-all`;
      const data = await repositoryDelivery.get<MessageResponse<any>>(url);
      const filteredData = data?.data.filter(
        (item: any) => item.fromBranchId === branchId
      );
      const dataStation = createDataStation(createDataStationMap(filteredData)); // apiData là dữ liệu từ API
      setDataStation(dataStation);
    };
    const getDetailBranch = async () => {
      const callapi = await repositoryDelivery.get<MessageResponse<any>>(
        `/api/v1/TblDMMasterOrg/detail?id=${branchId}`
      );

      if (callapi) {
        const dataApi = callapi?.data;
        if (dataApi != null) {
          setBranchName(dataApi.address);
        }
      }
    };
    getDetailBranch();
    handleFetchStation();
  }, [branchId]);

  const createDataStation = (data: any) => {
    if (!Array.isArray(data)) return [];

    return data.map((item) => ({
      value: String(item.id), // Giá trị sẽ là ID
      label: `${item.to_address} - ${item.attribute2}`, // Hiển thị tên nhà xe + địa chỉ
      distance: item?.distance,
    }));
  };
  const renderShippingTypeAndTime = () => {
    if (
      shipingVendor === "NV điều vận" ||
      shipingVendor === "Kỹ thuật" ||
      shipingVendor === "Dự án" ||
      shipingVendor === "Kỹ thuật thi công"
    ) {
      return (
        <>
          {" "}
          <Grid.Col
            span={5}
            style={{
              pointerEvents: readOnly ? "none" : "auto",
            }}
          >
            {" "}
            <Select
              disabled
              withAsterisk
              searchable
              clearable
              label="Loại vận chuyển"
              placeholder="Loại vận chuyển"
              data={SHIPPING_TYPE_OPTIONS}
              {...form.getInputProps("typeShip")}
            />
          </Grid.Col>
          <Grid.Col span={3}>
            <TextInput
              withAsterisk
              label="Giờ giao hàng dự kiến"
              placeholder="VD: 14:30"
              description="Định dạng 24h (HH:mm)"
              leftSection={<IconClock size={16} />}
              maxLength={5}
              onInput={(event: React.FormEvent<HTMLInputElement>) => {
                let value = event.currentTarget.value;
                // Chỉ cho phép nhập số và dấu :
                value = value.replace(/[^\d:]/g, "");

                // Tự động thêm dấu : sau 2 số đầu
                if (value.length === 2 && !value.includes(":")) {
                  value = value + ":";
                }

                // Giới hạn độ dài tối đa 5 ký tự (HH:mm)
                if (value.length > 5) {
                  value = value.substring(0, 5);
                }

                event.currentTarget.value = value;
                form.setFieldValue("timeDeliveryTime", value);
              }}
              {...form.getInputProps("timeDeliveryTime")}
            />
          </Grid.Col>
        </>
      );
    } else {
      return (
        <>
          {" "}
          <Grid.Col
            span={4}
            style={{
              pointerEvents: readOnly ? "none" : "auto",
            }}
          >
            {" "}
            <Select
              disabled
              withAsterisk
              searchable
              clearable
              label="Loại vận chuyển"
              placeholder="Loại vận chuyển"
              data={SHIPPING_TYPE_OPTIONS}
              {...form.getInputProps("typeShip")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              withAsterisk
              label="Giờ giao hàng dự kiến"
              placeholder="VD: 14:30"
              description="Định dạng 24h (HH:mm)"
              leftSection={<IconClock size={16} />}
              maxLength={5}
              onInput={(event: React.FormEvent<HTMLInputElement>) => {
                let value = event.currentTarget.value;
                // Chỉ cho phép nhập số và dấu :
                value = value.replace(/[^\d:]/g, "");

                // Tự động thêm dấu : sau 2 số đầu
                if (value.length === 2 && !value.includes(":")) {
                  value = value + ":";
                }

                // Giới hạn độ dài tối đa 5 ký tự (HH:mm)
                if (value.length > 5) {
                  value = value.substring(0, 5);
                }

                event.currentTarget.value = value;
                form.setFieldValue("timeDeliveryTime", value);
              }}
              {...form.getInputProps("timeDeliveryTime")}
            />
          </Grid.Col>
        </>
      );
    }
  };

  // ⚠️ DEPRECATED: Hàm này không dùng nữa - đã chuyển logic tính phí vào updateInternalHacomPartners()
  // const fetchDeliveryFareRates = async (distanceKm: number) => {
  //   try {
  //     // Round the distance to nearest integer before calling API
  //     const roundedDistance = Math.round(distanceKm);
  //     const response = await repositoryMdm.get<MessageResponse<any>>(
  //       `/api/v1/TblDmDeliveryFareRates/fee?distanceKm=${roundedDistance}`
  //     );

  //     if (response && response.success && response.data) {
  //       const fareAmount = response.data.fareAmount || 0; // Update only NV điều vận with the fare amount from API
  //       // Kỹ thuật, Dự án, Kỹ thuật thi công should always show "Không xác định" (fee = 0)
  //       setShippingPartners((prevPartners) =>
  //         prevPartners.map((partner) => {
  //           if (
  //             partner.description === "Nội bộ Hacom" &&
  //             partner.name === "NV điều vận"
  //           ) {
  //             return {
  //               ...partner,
  //               fee: fareAmount,
  //             };
  //           }
  //           return partner;
  //         })
  //       );
  //     } else {
  //     }
  //   } catch (error) {}
  // };

  // Function to get warehouse information based on branchId
  const getWarehouseInfo = (branchId: number): WarehouseInfo | null => {
    return (
      WAREHOUSE_DATA.find((warehouse) => warehouse.id === branchId) || null
    );
  };

  // Helper lấy thông tin kho/điểm lấy hàng (hỗ trợ văn phòng 124)
  const getEffectiveWarehouseInfo = useCallback((): WarehouseInfo | null => {
    if (isOffice124) {
      return {
        id: 124,
        pick_address: "124 Minh Khai, Hai Bà Trưng, Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Hai Bà Trưng",
        pick_ward: "Minh Khai",
        pick_tel: senderPhone || "0988655130",
      };
    }
    return getWarehouseInfo(branchId || 488);
  }, [isOffice124, senderPhone, branchId]);

  // Function to fetch GHTK delivery fee
  const fetchGhtkDeliveryFee = useCallback(async (options?: { specsResultOverride?: SpecificationsCheckResult | null }) => {
    try {
      setIsLoadingGHtkFee(true);

      const address = form.values.customerAddress || "";
      const provinceId = form.values.customerProvinceId?.toString() || "";
      const communeId = form.values.customerCommuneId?.toString() || "";

      // Get province, commune names for the delivery address - Lấy từ dropdown data để tránh sai mapping
      const selectedProvince = dataTblProvinceSelect.find(
        (item) => item.value === provinceId
      );
      const provinceName = selectedProvince?.label || "";

      if (!provinceName) {
        console.warn("Province name not found for provinceId:", provinceId);
        setIsLoadingGHtkFee(false);
        return;
      }

      const communeResponse = await repositoryMdm.get(
        `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${provinceId}`
      );
      const communeData = communeResponse?.data ?? [];
      const communeName =
        communeData.find((item: any) => item.value === communeId)?.text || "";

      // Get warehouse info for pick up address (văn phòng 124 hoặc chi nhánh)
      const warehouseInfo = getEffectiveWarehouseInfo();

      if (!warehouseInfo || !provinceName || !communeName) {
        setIsLoadingGHtkFee(false);
        return;
      }

      // Calculate distance for Giao hàng tiết kiệm estimated time
      const installTime = getTechnicalInstallationTime();
      let estimatedHours = 2; // Default 2 hours
      let estimatedTime = "2 giờ";

      // ⭐ Sử dụng cached distance thay vì gọi API lại
      const km = cachedDistanceKm || 10; // Default 10km nếu chưa có cache
      console.log("🚚 GHTK using cached distance:", { cachedDistanceKm, km });

      // < 3km: 2h, < 10km: 3h, > 10km: 4h
      if (km < 3) {
        estimatedHours = 2;
        estimatedTime = formatEstimatedTime(2);
      } else if (km < 10) {
        estimatedHours = 3;
        estimatedTime = formatEstimatedTime(3);
      } else {
        estimatedHours = 4;
        estimatedTime = formatEstimatedTime(4);
      }

      // Cộng thêm thời gian lắp đặt vào estimatedHours
      estimatedHours += installTime.hours;
      const orderValue = calculateOrderValue();
      let finalFee = 0;

      const effectiveSpecs = options?.specsResultOverride !== undefined ? options.specsResultOverride : specificationsResult;
      const isBulky = effectiveSpecs?.hasOverSizeItems;

      if (isBulky) {
        try {
          const payload = {
            pick_province: warehouseInfo.pick_province,
            pick_district: warehouseInfo.pick_district,
            pick_ward: warehouseInfo.pick_ward,
            pick_address: warehouseInfo.pick_address,
            province: provinceName,
            ward: communeName,
            address: address,
            // Cân nặng tổng tính bằng gram (totalWeight là kg, nhân 1000)
            weight: (effectiveSpecs?.totalWeight || 0) * 1000,
            value: cod || orderValue,
            deliver_option: "none",
            tags: ["1"],
            products: (listAdd || []).map((item: any) => {
              const spec = effectiveSpecs?.overSizeItemsDetails?.find(
                (s: any) => s.itemId === item.itemId
              );
              return {
                width: spec ? spec.width / 10 : 10,
                height: spec ? spec.height / 10 : 10,
                length: spec ? spec.length / 10 : 10,
                quantity: item.quality || item.quantity || 1,
                weight: spec ? String(spec.weight) : "1",
              };
            }),
          };

          const ghtkResponse = await repositoryPos.post<any>("/api/v1/ghtk/calculate-fee", payload);
          console.log("API GHTK Response:", ghtkResponse);

          if (ghtkResponse?.success) {
            const feeObj = ghtkResponse?.fee || ghtkResponse?.data?.fee;
            const feeValue = typeof feeObj === "object" && feeObj !== null
              ? Number(feeObj.fee)
              : Number(feeObj);
            if (!isNaN(feeValue)) {
              finalFee = feeValue;
            } else {
              finalFee = orderValue >= 300000 ? 0 : 15000;
            }
          } else {
            finalFee = orderValue >= 300000 ? 0 : 15000;
          }
        } catch (error) {
          console.error("Error calling calculate-fee:", error);
          finalFee = orderValue >= 300000 ? 0 : 15000;
        }
      } else {
        // Tính phí giống nội bộ Hacom: đơn >= 300k thì 0đ, ngược lại 15k
        finalFee = orderValue >= 300000 ? 0 : 15000;
      }

      setShippingPartners((prevPartners) =>
        prevPartners.map((partner) => {
          if (partner.name === "Giao hàng tiết kiệm") {
            return {
              ...partner,
              fee: finalFee,
              estimatedTime: estimatedTime,
              estimatedTimeNumber: estimatedHours,
              isDisabled: false,
              errorMessage: null,
              description: isBulky ? "Cồng Kềnh" : partner.description,
            };
          }
          // Các đơn vị nội bộ Hacom cũng lấy phí bằng GHTK nếu là hàng cồng kềnh
          if (isBulky && INTERNAL_PARTNER_NAMES.includes(partner.name)) {
            return {
              ...partner,
              fee: finalFee,
            };
          }
          return partner;
        })
      );
    } catch (error) {
      console.error("Error fetching Giao hàng tiết kiệm delivery fee:", error);
      NotificationExtension.Fails(
        "Không thể lấy phí giao hàng Giao hàng tiết kiệm. Sử dụng phí mặc định."
      );
    } finally {
      setIsLoadingGHtkFee(false);
    }
  }, [
    form.values.customerAddress,
    form.values.customerProvinceId,
    form.values.customerCommuneId,
    branchId,
    cod,
    branchName,
    dataTblProvinceSelect,
    getTechnicalInstallationTime,
    formatEstimatedTime,
    calculateOrderValue,
    listAdd,
    specificationsResult,
    isOffice124,
    senderPhone,
    getEffectiveWarehouseInfo,
  ]);

  // Function to fetch Ahamove delivery fee
  const fetchAhamoveDeliveryFee = useCallback(async () => {
    try {
      setIsLoadingAhamoveFee(true);

      const address = form.values.customerAddress || "";
      const provinceId = form.values.customerProvinceId?.toString() || "";
      const communeId = form.values.customerCommuneId?.toString() || "";

      // Get province, commune names for the delivery address - Lấy từ dropdown data để tránh sai mapping
      const selectedProvince = dataTblProvinceSelect.find(
        (item) => item.value === provinceId
      );
      const provinceName = selectedProvince?.label || "";

      if (!provinceName) {
        console.warn("Province name not found for provinceId:", provinceId);
        setIsLoadingAhamoveFee(false);
        return;
      }

      const communeResponse = await repositoryMdm.get(
        `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${provinceId}`
      );
      const communeData = communeResponse?.data ?? [];
      const communeName =
        communeData.find((item: any) => item.value === communeId)?.text || "";

      // Get warehouse info for pick up address (văn phòng 124 hoặc chi nhánh)
      const warehouseInfo = getEffectiveWarehouseInfo();

      if (!warehouseInfo || !provinceName || !communeName) {
        setIsLoadingAhamoveFee(false);
        return;
      }

      // Determine services based on delivery destination (province)
      // ⭐ Sử dụng địa chỉ giao hàng (provinceId) thay vì branchId để xác định vùng Ahamove
      const { isHCM } = isHanoiOrHCMProvince(provinceId);

      const services = isHCM
        ? [
          { _id: "SGN-BIKE" }, // Siêu tốc HCM
          { _id: "SGN-ECO" }, // Tiết kiệm HCM
          { _id: "SGN-TRUCK" }, // Xe tải HCM (nếu có)
        ]
        : [
          { _id: "HAN-BIKE" }, // Siêu tốc Hà Nội
          { _id: "HAN-ECO" }, // Tiết kiệm Hà Nội
          { _id: "HAN-SAMEPRICE" }, // Đồng giá 25k Hà Nội
        ];

      // Build full addresses
      const pickupAddress = `${warehouseInfo.pick_address}`;
      const deliveryAddress = `${address}, ${communeName}, ${provinceName}`; // Ahamove API payload
      const ahamovePayload = {
        order_time: 0,
        path: [
          {
            // lat: 21.0285, // Default Hanoi coordinates for pickup
            // lng: 105.8542,
            address: pickupAddress,
            short_address: `${warehouseInfo.pick_district}, ${warehouseInfo.pick_province}`,
            name: isOffice124 ? "Văn phòng Hacom 124" : "Hacom Store",
            mobile: warehouseInfo.pick_tel,
            remarks: "Đến nơi lấy hàng đọc mã đơn để nhận hàng",
          },
          {
            // lat: 21.0285, // Default coordinates - in production should use geocoding
            // lng: 105.8542,
            address: deliveryAddress,
            short_address: `${communeName}, ${provinceName}`,
            name: form.values.customerName || "Khách hàng",
            mobile: form.values.telephoneNumber || "0123456789",
            // Business rule: Set COD to 0 if payment type is not COD
            cod: payType !== "Giao Hàng Thu Tiền(COD)" ? 0 : cod || 0,
            item_value: cod || 0,
            tracking_number: `ORDER_${Date.now()}`,
            remarks: "Gọi điện trước khi giao. Giao hàng cẩn thận",
          },
        ],
        services: services,
        payment_method: "CASH",
        remarks: "Đơn hàng từ Hacom",
        items:
          listAdd && listAdd.length > 0
            ? listAdd.map((item: any, index: number) => ({
              _id: item.itemCode || `ITEM_${index}`,
              num: item.quality || 1,
              name: item.itemName || "Sản phẩm",
              price: item.priceFinal || item.priceOnPriceList || 0,
            }))
            : [
              {
                _id: "ITEM",
                num: 1,
                name: "Sản phẩm điện tử",
                price: cod || 100000,
              },
            ],
        package_detail: [
          {
            weight: 1, // Default 1kg
            length: 1,
            width: 1,
            height: 1,
            description: "Hàng điện tử",
          },
        ],
      };

      // ⭐ Sử dụng cached distance thay vì gọi API lại
      const calculatedDistanceKm = cachedDistanceKm || 10; // Default 10km nếu chưa có cache
      console.log("🚚 Ahamove using cached distance:", {
        cachedDistanceKm,
        calculatedDistanceKm,
      });

      // Call Ahamove API using the new function
      const response = await getAhamoveEstimates(ahamovePayload);

      if (response && Array.isArray(response)) {
        // Update Ahamove partners in the shipping partners array
        setShippingPartners((prevPartners) =>
          prevPartners.map((partner) => {
            if (partner.name === "Ahamove") {
              // Map based on partner description and delivery destination (province)
              let targetServiceId = "";
              if (partner.description === "Siêu tốc") {
                targetServiceId = isHCM ? "SGN-BIKE" : "HAN-BIKE";
              } else if (partner.description === "Siêu tốc tiết kiệm") {
                targetServiceId = isHCM ? "SGN-ECO" : "HAN-ECO";
              }

              // Find the estimate for this specific service
              const estimate = response.find(
                (item: any) => item.service_id === targetServiceId
              );

              if (estimate) {
                // Check if there's an error in the response
                if (estimate.error) {
                  // Handle error case - set error message and disable service
                  return {
                    ...partner,
                    fee: 0,
                    errorMessage:
                      estimate.error.description ||
                      estimate.error.title ||
                      "Dịch vụ không khả dụng",
                    isDisabled: true,
                    estimatedTime: partner.estimatedTime,
                    estimatedTimeNumber: partner.estimatedTimeNumber,
                  };
                } else if (estimate.data) {
                  // Handle success case
                  const fee = estimate.data.total_pay || partner.fee;

                  // Calculate estimated time based on distance and service type
                  const installTime = getTechnicalInstallationTime();
                  let estimatedTime = partner.estimatedTime;
                  let estimatedTimeNumber = 2; // Default 2 hours

                  if (partner.description === "Siêu tốc") {
                    if (calculatedDistanceKm < 6) {
                      estimatedTimeNumber = 1;
                      estimatedTime = formatEstimatedTime(1);
                    } else if (calculatedDistanceKm < 20) {
                      estimatedTimeNumber = 2;
                      estimatedTime = formatEstimatedTime(2);
                    } else {
                      estimatedTimeNumber = 2;
                      estimatedTime = formatEstimatedTime(2);
                    }
                  } else if (partner.description === "Siêu tốc tiết kiệm") {
                    if (calculatedDistanceKm < 6) {
                      estimatedTimeNumber = 1;
                      estimatedTime = formatEstimatedTime(1);
                    } else if (calculatedDistanceKm < 20) {
                      estimatedTimeNumber = 2;
                      estimatedTime = formatEstimatedTime(2);
                    } else {
                      estimatedTimeNumber = 2;
                      estimatedTime = formatEstimatedTime(2);
                    }
                  }
                  // Cộng thêm thời gian lắp đặt
                  estimatedTimeNumber += installTime.hours;

                  return {
                    ...partner,
                    fee: fee,
                    estimatedTime: estimatedTime,
                    estimatedTimeNumber: estimatedTimeNumber,
                    errorMessage: null,
                    isDisabled: false,
                  };
                }
              }
            }
            return partner;
          })
        );
      } else {
        console.warn("Ahamove API returned no estimates or error:", response);
        // Set error state for Ahamove partners
        setShippingPartners((prevPartners) =>
          prevPartners.map((partner) =>
            partner.name === "Ahamove"
              ? {
                ...partner,
                isDisabled: true,
                errorMessage: "Không thể lấy phí từ API",
              }
              : partner
          )
        );
      }
    } catch (error) {
      console.error("Error fetching Ahamove delivery fee:", error);
      NotificationExtension.Fails(
        "Không thể lấy phí giao hàng Ahamove. Sử dụng phí mặc định."
      );
      // Set error state for Ahamove partners
      setShippingPartners((prevPartners) =>
        prevPartners.map((partner) =>
          partner.name === "Ahamove"
            ? {
              ...partner,
              isDisabled: true,
              errorMessage: "Lỗi khi gọi API",
            }
            : partner
        )
      );
    } finally {
      setIsLoadingAhamoveFee(false);
    }
  }, [
    form.values.customerAddress,
    form.values.customerProvinceId,
    form.values.customerCommuneId,
    form.values.customerName,
    form.values.telephoneNumber,
    branchId,
    cod,
    branchName,
    listAdd,
    payType,
    dataTblProvinceSelect,
    getTechnicalInstallationTime,
    formatEstimatedTime,
    isOffice124,
    senderPhone,
    getEffectiveWarehouseInfo,
  ]);

  // Function to recalculate fees for all partners based on inner city / order value logic
  const fetchGrabExpressDeliveryFee = useCallback(async () => {
    try {
      setIsLoadingGrabFee(true);

      const address = form.values.customerAddress || "";
      const provinceId = form.values.customerProvinceId?.toString() || "";
      const communeId = form.values.customerCommuneId?.toString() || "";

      const selectedProvince = dataTblProvinceSelect.find(
        (item) => item.value === provinceId
      );
      const provinceName = selectedProvince?.label || "";

      if (!provinceName) {
        setIsLoadingGrabFee(false);
        return;
      }

      const communeResponse = await repositoryMdm.get(
        `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${provinceId}`
      );
      const communeData = communeResponse?.data ?? [];
      const communeName =
        communeData.find((item: any) => item.value === communeId)?.text || "";

      const warehouseInfo = getWarehouseInfo(branchId || 488);

      if (!warehouseInfo || !provinceName || !communeName) {
        setIsLoadingGrabFee(false);
        return;
      }

      const pickupAddress = `${warehouseInfo.pick_address}, ${warehouseInfo.pick_ward}, ${warehouseInfo.pick_district}, ${warehouseInfo.pick_province}`;
      const deliveryAddress = `${address}, ${communeName}, ${provinceName}`;

      // Mặc định toạ độ Hà Nội để vượt qua lỗi 400 (vì Grab bắt buộc có coordinates)
      // Trong tương lai cần có API Geocoding để lấy toạ độ chính xác cho từng địa chỉ
      const defaultLat = provinceName.toLowerCase().includes("hồ chí minh") ? 10.8231 : 21.0285;
      const defaultLng = provinceName.toLowerCase().includes("hồ chí minh") ? 106.6297 : 105.8542;

      const grabPayload = {
        serviceType: "INSTANT",
        origin: {
          address: pickupAddress,
          coordinates: {
            latitude: defaultLat,
            longitude: defaultLng
          }
        },
        destination: {
          address: deliveryAddress,
          coordinates: {
            latitude: defaultLat + 0.01, // TODO: Cần geocode địa chỉ nhận. Thêm offset nhỏ để tránh lỗi khoảng cách = 0
            longitude: defaultLng + 0.01
          }
        }
      };

      const response = await getGrabExpressQuotes(grabPayload);
      if (response && response.quotes && response.quotes.length > 0) {
         const quote = response.quotes[0];
         const fee = quote.amount || 0;
         
         setShippingPartners((prevPartners) =>
          prevPartners.map((partner) => {
            if (partner.name === "Grab") {
              return {
                ...partner,
                fee: fee,
                estimatedTime: "2 giờ",
                estimatedTimeNumber: 2,
                errorMessage: null,
                isDisabled: false,
              };
            }
            return partner;
          })
        );
      } else {
          setShippingPartners((prevPartners) =>
          prevPartners.map((partner) => {
            if (partner.name === "Grab") {
              return {
                ...partner,
                fee: 0,
                errorMessage: response?.message || "Dịch vụ không khả dụng",
                isDisabled: true,
              };
            }
            return partner;
          })
        );
      }
    } catch (error) {
      console.error("Error fetching GrabExpress delivery fee:", error);
      NotificationExtension.Fails(
        "Không thể lấy phí giao hàng GrabExpress. Sử dụng phí mặc định."
      );
      setShippingPartners((prevPartners) =>
        prevPartners.map((partner) =>
          partner.name === "Grab"
            ? {
              ...partner,
              isDisabled: true,
              errorMessage: "Lỗi khi gọi API",
            }
            : partner
        )
      );
    } finally {
      setIsLoadingGrabFee(false);
    }
  }, [
    form.values.customerAddress,
    form.values.customerProvinceId,
    form.values.customerCommuneId,
    branchId,
    dataTblProvinceSelect,
  ]);

  const internalPartnerSet = useMemo(() => new Set(INTERNAL_PARTNER_NAMES), []);

  const recalculateAllPartnerFees = useCallback(
    async (options?: {
      specsResultOverride?: SpecificationsCheckResult | null;
    }) => {
      const provinceId = form.values.customerProvinceId?.toString() || "";
      const communeId = form.values.customerCommuneId?.toString() || "";

      if (!provinceId || !communeId) {
        console.log("⚠️ Missing province or commune ID, skip recalculation");
        return;
      }

      // Tính tổng giá trị đơn hàng
      let orderValue = 0;
      if (listAdd && listAdd.length > 0) {
        orderValue = listAdd.reduce((total: number, item: any) => {
          const itemPrice = item.priceFinal || item.priceOnPriceList || 0;
          const itemQuality = item.quality || 1;
          return total + itemPrice * itemQuality;
        }, 0);
      }

      const effectiveSpecs =
        options?.specsResultOverride ?? specificationsResult;

      // ⚖️ Tính phí cồng kềnh từ trọng lượng của các item có isCongKenh = true
      const totalWeight = effectiveSpecs?.totalWeight || 0;
      const bulkyWeight = effectiveSpecs?.hasOverSizeItems
        ? effectiveSpecs.overSizeItemsDetails.reduce(
            (sum: number, item: any) => sum + item.totalWeight,
            0
          )
        : 0;
      const bulkyFee = calculateBulkyItemFee(bulkyWeight);

      // Check nội thành
      const { isHanoi, isHCM } = isHanoiOrHCMProvince(provinceId);
      let isInnerCity = false;

      if (isHanoi || isHCM) {
        const { isFreeShipWard } = await import(
          "./constants/modalDeliveryConstants"
        );
        isInnerCity = isFreeShipWard(String(communeId));
      }

      console.log("🔄 Recalculating all partner fees:", {
        provinceId,
        communeId,
        orderValue,
        isInnerCity,
        bulkyFee,
        totalWeight,
      });

      // Cập nhật phí cho từng đối tác
      setShippingPartners((prevPartners) => {
        const updatedPartners = prevPartners.map((partner) => {
          console.log(`🔍 DEBUG - Recalculating ${partner.name}:`, {
            currentFee: partner.fee,
            bulkyFee,
            shouldAddBulky:
              partner.name !== "Ahamove" &&
              partner.name !== "Giao hàng tiết kiệm",
          });

          // ⭐ Ahamove, GHTK, Grab - GIỮ NGUYÊN phí từ API (đã bao gồm cồng kềnh)
          if (
            partner.name === "Ahamove" ||
            partner.name === "Giao hàng tiết kiệm" ||
            partner.name === "Grab"
          ) {
            console.log(
              `🚀 ${partner.name}: Giữ nguyên phí API = ${partner.fee} (không cộng bulky)`
            );
            return { ...partner }; // Giữ nguyên, không thay đổi
          }

          // ⚠️ COD (Kho đóng gói) & NỘI BỘ HACOM - Phí cơ bản (15k hoặc 0), không cộng bulky fee
          // Không bị ảnh hưởng bởi chính sách miễn phí nội thành
          if (
            partner.name === "COD" ||
            partner.name === "Kho đóng gói" ||
            internalPartnerSet.has(partner.name)
          ) {
            let baseFee = orderValue >= 300000 ? 0 : 15000;
            const effectiveSpecs = options?.specsResultOverride ?? specificationsResult;
            if (effectiveSpecs?.hasOverSizeItems && internalPartnerSet.has(partner.name)) {
              const ghtkPartner = prevPartners.find(p => p.name === "Giao hàng tiết kiệm");
              baseFee = ghtkPartner?.fee || baseFee;
            }
            console.log(`💵 ${partner.name}: ${baseFee}`);
            return { ...partner, fee: baseFee };
          }

          // Nội thành - MIỄN PHÍ HOÀN TOÀN (kể cả hàng cồng kềnh) cho các đối tác khác
          if (isInnerCity) {
            console.log(
              `✅ ${partner.name}: FREE shipping (inner city, including bulky items)`
            );
            return { ...partner, fee: 0 };
          }

          // Ngoại thành - Check theo giá trị đơn hàng và đối tác


          // Các đối tác khác
          if (orderValue >= 300000) {
            console.log(
              `✅ ${partner.name}: FREE (>=300k) + bulky ${bulkyFee}`
            );
            return { ...partner, fee: bulkyFee };
          }

          // Giữ nguyên phí hiện tại + bulky fee
          const totalFee = partner.fee + bulkyFee;
          console.log(
            `📌 ${partner.name}: ${partner.fee} + ${bulkyFee} = ${totalFee}`
          );
          return { ...partner, fee: totalFee };
        });

        return updatedPartners;
      });
    },
    [
      form.values.customerProvinceId,
      form.values.customerCommuneId,
      listAdd,
      specificationsResult,
      calculateBulkyItemFee,
      isHanoiOrHCMProvince,
      internalPartnerSet,
    ]
  );

  // Function to update COD fee based on order value
  const updateCodFee = useCallback(() => {
    // Tính tổng giá trị đơn hàng
    let orderValue = 0;
    if (listAdd && listAdd.length > 0) {
      orderValue = listAdd.reduce((total: number, item: any) => {
        const itemPrice = item.priceFinal || item.priceOnPriceList || 0;
        const itemQuality = item.quality || 1;
        return total + itemPrice * itemQuality;
      }, 0);
    }

    // Tính phí COD
    let codFee = 0;
    if (orderValue >= 300000) {
      codFee = 0; // Miễn phí cho đơn >= 300k
    } else {
      codFee = 15000; // Phí cố định cho đơn < 300k
    }

    console.log("💵 Updating COD fee:", { orderValue, codFee });

    // Cập nhật phí COD vào shippingPartners
    // ⚠️ Chỉ cập nhật phí, GIỮ NGUYÊN estimatedTime và estimatedTimeNumber
    setShippingPartners((prevPartners) =>
      prevPartners.map((partner) =>
        partner.name === "COD" || partner.name === "Kho đóng gói"
          ? {
            ...partner,
            fee: codFee,
            // Giữ nguyên estimatedTime và estimatedTimeNumber từ mặc định
          }
          : partner
      )
    );
  }, [listAdd]);

  // Update COD fee when order items change (listAdd)
  useEffect(() => {
    if (listAdd && listAdd.length > 0) {
      updateCodFee();
    }
  }, [listAdd, updateCodFee]);

  // Function to automatically calculate distance and update internal Hacom partners
  const updateInternalHacomPartners = async (): Promise<boolean> => {
    try {
      const address = form.values.customerAddress || "";
      const provinceId = form.values.customerProvinceId?.toString() || "";
      const communeId = form.values.customerCommuneId?.toString() || "";

      if (!address || !provinceId || !communeId) {
        return false; // Don't update if required fields are missing
      }

      // Resolve names for address - Lấy tên tỉnh từ dropdown data để tránh sai mapping
      const selectedProvince = dataTblProvinceSelect.find(
        (item) => item.value === provinceId
      );
      const provinceName = selectedProvince?.label || "";

      if (!provinceName) {
        console.warn("Province name not found for provinceId:", provinceId);
        return false;
      }

      const communeResponse = await repositoryMdm.get(
        `/api/v1/TblDmCommuneMoi/get-select?ProvinceIds=${provinceId}`
      );
      const communeData = communeResponse?.data ?? [];
      const communeName =
        communeData.find((item: any) => item.value === communeId)?.text || "";

      const fullAddress = `${address}, ${communeName}, ${provinceName}`;
      const originAddress = isOffice124
        ? "124 Minh Khai, Hai Bà Trưng, Hà Nội"
        : branchName;
      const dataFromAddress = originAddress ? [originAddress] : [];
      const processedData = [fullAddress];

      if (dataFromAddress.length === 0) {
        console.warn("Branch name / origin address is null, cannot calculate distance");
        return false;
      }

      const res = await calculateDistanceMatrix(dataFromAddress, processedData);

      if (res && res?.success) {
        const dataApi = res.data.rows;
        const element = dataApi.flatMap((row: any) => row.elements)[0];

        // DEBUG: Log raw distance
        console.log("🔍 DEBUG updateInternalHacomPartners - Raw distance:", {
          rawMeters: element.distance.value,
          rawKm: element.distance.value / 1000,
        });

        // Làm tròn LÊN km để tính phí (20.68km → 21km)
        const km = Math.ceil(element.distance.value / 1000);
        setCalculatedDistance(km);
        setCachedDistanceKm(km); // ⭐ Lưu vào cache để tái sử dụng

        console.log("🔍 DEBUG updateInternalHacomPartners - After rounding:", {
          km,
        });

        // Calculate estimated time and fee based on province and distance
        let estimatedTime = "";
        let estimatedTimeNumber = 0;
        let shippingFee = 0;
        const internalDistanceFee = calculateInternalDistanceFee(km);

        // Lấy thời gian lắp đặt
        const installTime = getTechnicalInstallationTime();

        // Check if Hanoi or HCM
        const { isHanoi, isHCM } = isHanoiOrHCMProvince(provinceId);
        const isHanoiOrHCM = isHanoi || isHCM;
        const orderValue = calculateOrderValue();
        let isInnerCity = false;

        if (isHanoiOrHCM) {
          // Import free ship ward checker
          const { isFreeShipWard } = await import(
            "./constants/modalDeliveryConstants"
          );
          isInnerCity = isFreeShipWard(String(communeId));

          if (isInnerCity) {
            // Nội thành: Hà Nội 2-4h, HCM 2-5h
            if (isHanoi) {
              estimatedTimeNumber = 4 + installTime.hours;
              estimatedTime = formatEstimatedTime(4);
            } else {
              estimatedTimeNumber = 5 + installTime.hours;
              estimatedTime = formatEstimatedTime(5);
            }
            shippingFee = calculateInternalStandardFee(orderValue);
          } else if (km < 50) {
            // Ngoại thành (<50km): 4-8h
            estimatedTimeNumber = 8 + installTime.hours;
            estimatedTime = formatEstimatedTime(8);

            shippingFee = calculateInternalStandardFee(orderValue);

            console.log(
              "🚚 Internal partners (updateInternalHacomPartners): Standard fee:",
              {
                km,
                shippingFee,
              }
            );

            // 🔍 DEBUG: Tính phí cồng kềnh để kiểm tra
            const debugBulkyWeight = specificationsResult?.hasOverSizeItems
              ? specificationsResult.overSizeItemsDetails.reduce(
                  (sum: number, item: any) => sum + item.totalWeight,
                  0
                )
              : 0;
            const debugBulkyFee = calculateBulkyItemFee(debugBulkyWeight);

            console.log(
              "🚚 NV điều vận fee (updateInternalHacomPartners) FINAL:",
              {
                km,
                shippingFee,
                bulkyWeight: debugBulkyWeight,
                bulkyFee: debugBulkyFee,
                willAddBulkyLater: true,
                IMPORTANT: "THIS shippingFee will be set to partner.fee",
              }
            );
          } else {
            // Không xác định nếu >50km
            estimatedTime = "Không xác định";
            estimatedTimeNumber = 0;
            shippingFee = 0;
          }
        } else {
          // Tỉnh/TP khác: 2-6 ngày - sử dụng API đối tác
          estimatedTime = "từ 02 đến 06 ngày" + installTime.text;
          estimatedTimeNumber = 144 + installTime.hours; // 6 ngày * 24 giờ + thời gian lắp đặt
          shippingFee = calculateInternalStandardFee(orderValue);
        }

        const isExpressAllowed = km <= 15;

        // Always update internal partners (even if fee is 0 - means free shipping)
        setShippingPartners((prevPartners) =>
          prevPartners.map((partner) => {
            // Logic mới: phí nội bộ = 15k (<300k) hoặc 0 (>=300k)
            let resolvedFee = orderValue >= 300000 ? 0 : 15000;
            if (specificationsResult?.hasOverSizeItems) {
              const ghtkPartner = prevPartners.find(p => p.name === "Giao hàng tiết kiệm");
              resolvedFee = ghtkPartner?.fee || resolvedFee;
            }
            // Update only internal Hacom partners, preserve other partners' data
            if (partner.description === "Nội bộ Hacom") {
              // ⭐ KỸ THUẬT - Tính theo bảng khoảng cách
              if (partner.name === "Kỹ thuật") {
                let techEstimatedTime = "";
                let techEstimatedTimeNumber = 0;

                if (isHanoi) {
                  // Hà Nội: <10km: 6h, 10-20km: 8h, >20km: 12h
                  if (km < 10) {
                    techEstimatedTimeNumber = 6;
                    techEstimatedTime = formatEstimatedTime(6);
                  } else if (km <= 20) {
                    techEstimatedTimeNumber = 8;
                    techEstimatedTime = formatEstimatedTime(8);
                  } else {
                    techEstimatedTimeNumber = 12;
                    techEstimatedTime = formatEstimatedTime(12);
                  }
                } else if (isHCM) {
                  // HCM: <10km: 8h, 10-20km: 16h, >20km: 24h
                  if (km < 10) {
                    techEstimatedTimeNumber = 8;
                    techEstimatedTime = formatEstimatedTime(8);
                  } else if (km <= 20) {
                    techEstimatedTimeNumber = 16;
                    techEstimatedTime = formatEstimatedTime(16);
                  } else {
                    techEstimatedTimeNumber = 24;
                    techEstimatedTime = formatEstimatedTime(24);
                  }
                } else {
                  // Tỉnh/TP khác: <=20km: 8h, >20km: 32h
                  if (km <= 20) {
                    techEstimatedTimeNumber = 8;
                    techEstimatedTime = formatEstimatedTime(8);
                  } else {
                    techEstimatedTimeNumber = 32;
                    techEstimatedTime = formatEstimatedTime(32);
                  }
                }

                // Cộng thêm thời gian lắp đặt
                techEstimatedTimeNumber += installTime.hours;

                return {
                  ...partner,
                  estimatedTime: techEstimatedTime,
                  estimatedTimeNumber: techEstimatedTimeNumber,
                  fee: resolvedFee,
                };
              }

              // ⭐ NV ĐIỀU VẬN - Miễn phí 10km đầu tiên, từ km thứ 11 tính 3.000đ/km
              if (partner.name === "NV điều vận") {
                // Logic đã được tính trong shippingFee ở trên
                // Nếu chọn hỏa tốc thì dùng bảng khoảng cách 3km đầu 21.000đ

                console.log(
                  "✅ updateInternalHacomPartners - Setting NV điều vận fee:",
                  {
                    oldFee: partner.fee,
                    newFee: shippingFee,
                    willSet: shippingFee,
                  }
                );

                return {
                  ...partner,
                  estimatedTime: estimatedTime,
                  estimatedTimeNumber: estimatedTimeNumber,
                  fee: resolvedFee,
                };
              }

              // ⚠️ COD - Giữ nguyên thời gian mặc định
              if (partner.name === "COD") {
                return {
                  ...partner,
                  fee: resolvedFee, // Chỉ cập nhật phí
                };
              }

              // ⭐ Kỹ thuật, Dự án, Kỹ thuật thi công - Đồng bộ phí với NV điều vận
              return {
                ...partner,
                estimatedTime: estimatedTime,
                estimatedTimeNumber: estimatedTimeNumber,
                fee: resolvedFee,
              };
            }
            // Keep other partners unchanged (preserve GHTK, Ahamove fees)
            return partner;
          })
        );
        return true;
      }
    } catch (error) {
      console.error("Error calculating distance for internal partners:", error);
      return false;
    }
    return false;
  };

  const handleOpenShippingPartnerModal = async () => {
    if (isOffice124 && (!senderPhone || !senderPhone.trim())) {
      setSenderPhoneError("Vui lòng nhập số điện thoại người gửi đơn hàng!");
      NotificationExtension.Fails(
        "Vui lòng nhập số điện thoại người gửi đơn hàng cho văn phòng 124!"
      );
      return;
    }
    setIsPreparingShippingFee(true);
    try {
      // Kiểm tra specs trước
      const specsResult = await checkProductSpecifications(listAdd, cod);
      setSpecificationsResult(specsResult);
      if (specsResult.hasOverSizeItems) {
        NotificationExtension.Warn(
          `Phát hiện ${specsResult.overSizeItemsDetails.length} sản phẩm có kích thước/trọng lượng vượt quá giới hạn thông thường. Vui lòng kiểm tra lại các đối tác vận chuyển phù hợp.`
        );
      }

      // Tự động tính toán khoảng cách và phí giao hàng khi mở popup
      const address = form.values.customerAddress || "";
      const provinceId = form.values.customerProvinceId?.toString() || "";
      const communeId = form.values.customerCommuneId?.toString() || "";

      // BƯỚC 1: Update internal Hacom partners TRƯỚC (thời gian & phí ship)
      // Đảm bảo các đối tác nội bộ được cập nhật trước khi fetch API thứ 3
      // ⭐ updateInternalHacomPartners đã tính khoảng cách và set vào calculatedDistance rồi
      const distanceSuccess = await updateInternalHacomPartners();

      if (!distanceSuccess) {
        NotificationExtension.Warn(
          "Không thể tính được khoảng cách giao hàng. Vui lòng kiểm tra lại địa chỉ hoặc thử lại sau."
        );
      }

      // BƯỚC 2: Đã bỏ - khoảng cách đã được tính trong updateInternalHacomPartners
      // Không cần gọi calculateDistanceMatrix thêm lần nữa

      // Helper: chỉ tính phí khi đã có đủ dữ liệu (km + specs)
      const canRecalculateFees = distanceSuccess && !!specsResult;
      const queueRecalculation = () => {
        if (!canRecalculateFees) {
          console.warn(
            "⏳ Skip recalculating shipping fees - missing distance/spec data",
            { distanceSuccess, hasSpecs: !!specsResult }
          );
          return;
        }
        setTimeout(
          () =>
            recalculateAllPartnerFees({
              specsResultOverride: specsResult,
            }),
          100
        );
      };

      // BƯỚC 3: Mở modal và fetch API của các đối tác thứ 3 (GHTK, Ahamove, COD)
      setOpenShippingPartnerModal(true);

      // Fetch third-party shipping fees if all required fields are present
      if (address && provinceId && communeId) {
        // Define warehouse list that only supports GHTK (không hỗ trợ Ahamove)
        const ghtkOnlyWarehouses: number[] = [];
        const isGhtkOnlyWarehouse = ghtkOnlyWarehouses.includes(branchId || 0);

        if (isGhtkOnlyWarehouse) {
          // Chỉ gọi GHTK API
          fetchGhtkDeliveryFee({ specsResultOverride: specsResult })
            .then(() => {
              // Đợi state update xong rồi mới tính lại phí (cộng bulky fee)
              queueRecalculation();
            })
            .catch((error) => {
              console.error("Error fetching GHTK delivery fee:", error);
              queueRecalculation();
            });
        } else {
          // Gọi cả GHTK, Ahamove, Grab APIs song song
          Promise.all([fetchGhtkDeliveryFee({ specsResultOverride: specsResult }), fetchAhamoveDeliveryFee(), fetchGrabExpressDeliveryFee()])
            .then(() => {
              // Đợi state update xong rồi mới tính lại phí (cộng bulky fee)
              queueRecalculation();
            })
            .catch((error) => {
              console.error("Error fetching delivery fees:", error);
              queueRecalculation();
            });
        }
      } else {
        // Nếu không có địa chỉ đầy đủ, vẫn tính lại phí cho các đối tác
        queueRecalculation();
      }
    } catch (error) {
      console.error("Error preparing shipping partner modal:", error);
      NotificationExtension.Fails(
        "Không thể chuẩn bị dữ liệu vận chuyển. Vui lòng thử lại."
      );
    } finally {
      setIsPreparingShippingFee(false);
    }
  };
  const getPartnerCodLimit = (partner: ShippingPartner) => {
    const normalizePartnerName = (name: string) =>
      (name || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();

    const normalizedName = normalizePartnerName(partner.name);
    const isGhtkPartner =
      normalizedName === "ghtk" ||
      normalizedName.includes("giao hang tiet kiem");
    const isAhamovePartner = normalizedName.includes("ahamove");

    if (isGhtkPartner) return 20000000;
    if (isAhamovePartner && partner.description === "Siêu tốc")
      return 10000000;
    if (isAhamovePartner && partner.description === "Siêu tốc tiết kiệm")
      return 10000000;
    return null;
  };

  const handleSelectShippingPartner = (partner: ShippingPartner) => {
    const normalizePartnerName = (name: string) =>
      (name || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    const normalizedName = normalizePartnerName(partner.name);
    const isAhamovePartner = normalizedName.includes("ahamove");
    const isGhtkPartner =
      normalizedName === "ghtk" ||
      normalizedName.includes("giao hang tiet kiem");

    // Only check COD limit when payment type is "Giao Hàng Thu Tiền(COD)"
    if (payType === "Giao Hàng Thu Tiền(COD)") {
      const codLimit = getPartnerCodLimit(partner);
      if (codLimit !== null && typeof cod === "number" && cod > codLimit) {
        NotificationExtension.Warn(
          `Số tiền thu hộ (COD) vượt quá giới hạn cho đối tác này.\nGiới hạn: ${codLimit.toLocaleString()} đ.\nVui lòng chọn đối tác khác hoặc giảm số tiền COD.`
        );
        return;
      }
    }
    // Lưu thông tin đối tác: name + description để phân biệt các loại Ahamove
    if (isAhamovePartner) {
      // Ahamove: Lưu description để phân biệt "Siêu tốc" vs "Siêu tốc tiết kiệm"
      form.setFieldValue(
        "shippingVendor",
        `${partner.name} ${partner.description}`
      );
    } else {
      form.setFieldValue("shippingVendor", partner.name);
    }

    // ⭐ Cập nhật phí ship để hiển thị ngay trên form
    // Lưu vào cả form và dataDeliveryInformation để đồng bộ
    const partnerFee = partner.fee || 0;

    console.log("🔥 DEBUG handleSelectShippingPartner:", {
      partnerName: partner.name,
      partnerDescription: partner.description,
      partnerFee: partnerFee,
      beforeUpdate_dataDeliveryInfo: dataDeliveryInformation?.deliveryFee,
      beforeUpdate_formValue: form.values.deliveryFee,
    });

    const isLockedShippingFee = !!orderHeader?.attribute49 && String(orderHeader?.saleChanelId) === "68";
    const feeToChargeCustomer = isLockedShippingFee
      ? (form.values.deliveryFee !== undefined && form.values.deliveryFee !== ""
          ? Number(form.values.deliveryFee)
          : partnerFee)
      : partnerFee;

    form.setFieldValue("deliveryFee", feeToChargeCustomer.toString());

    // ⭐ Update display value ngay lập tức
    setDisplayDeliveryFee(feeToChargeCustomer);

    setDataDeliveryInformation((prev: any) => {
      const updated = {
        ...prev,
        deliveryFee: feeToChargeCustomer,
      };
      console.log("📦 Updated dataDeliveryInformation:", updated);

      // ⭐ Force re-render sau khi update
      setTimeout(() => {
        console.log("🔄 Check after update:", {
          deliveryFee: updated.deliveryFee,
          inputShouldShow: partnerFee,
        });
      }, 200);

      return updated;
    });

    // Cập nhật luôn vào orderHeader.attribute3 nếu có setOrderHeader
    if (setOrderHeader) {
      setOrderHeader((prevOrderHeader: any) => {
        const updated = {
          ...prevOrderHeader,
          attribute3: partnerFee,
          shippingPriority:
            isGhtkPartner || isAhamovePartner
              ? "1"
              : "0",
        };
        console.log("📋 Updated orderHeader.attribute3:", updated.attribute3);
        return updated;
      });
    }

    // Set typeShip based on partner selection and express option
    if (isAhamovePartner) {
      form.setFieldValue("typeShip", partner.description || "Siêu tốc");
    } else if (isGhtkPartner) {
      form.setFieldValue("typeShip", isGhtkExpressType ? "Hỏa tốc" : "Thường");
    } else if (partner.description === "Nội bộ Hacom") {
      form.setFieldValue("typeShip", "Nội bộ Hacom");
    } else if (partner.description) {
      form.setFieldValue("typeShip", partner.description);
    }

    // Auto-calculate delivery time if estimatedTimeNumber is available
    // ⚠️ KHÔNG tính nếu:
    // - Là COD (thời gian "từ 02 đến 06 ngày" - 144 giờ)
    // - estimatedTime chứa chữ "ngày" (thời gian không chính xác, quá dài)
    const shouldCalculateDeliveryTime =
      partner.name !== "COD" &&
      partner.estimatedTimeNumber &&
      partner.estimatedTimeNumber > 0 &&
      !partner.estimatedTime.toLowerCase().includes("ngày");

    if (shouldCalculateDeliveryTime) {
      const now = new Date();

      // ⭐ GIỚI HẠN GIỜ LÀM VIỆC: 8h-18h (10 tiếng/ngày)
      const WORK_START = 8; // 8h sáng
      const WORK_END = 18; // 18h chiều
      const WORK_HOURS_PER_DAY = WORK_END - WORK_START; // 10 tiếng

      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();

      // Tách phần giờ và phút từ estimatedTimeNumber (số thập phân)
      const totalEstimatedHours = partner.estimatedTimeNumber;

      // Tính số giờ còn lại trong ngày hôm nay (từ giờ hiện tại đến 18h)
      let remainingHoursToday = 0;
      if (currentHour < WORK_END) {
        remainingHoursToday = WORK_END - currentHour - currentMinute / 60;
      }

      // Tính delivery time
      let deliveryDate = new Date(now);
      let deliveryHour = currentHour;
      let deliveryMinute = currentMinute;
      let remainingTime = totalEstimatedHours;

      // Nếu hiện tại đã ngoài giờ làm việc (>= 18h hoặc < 8h), bắt đầu từ 8h ngày hôm sau
      if (currentHour >= WORK_END || currentHour < WORK_START) {
        if (currentHour >= WORK_END) {
          deliveryDate.setDate(deliveryDate.getDate() + 1);
        }
        deliveryHour = WORK_START;
        deliveryMinute = 0;
        remainingHoursToday = WORK_HOURS_PER_DAY;
      }

      // Nếu thời gian giao hàng <= số giờ còn lại hôm nay
      if (remainingTime <= remainingHoursToday) {
        // Giao trong ngày
        const additionalHours = Math.floor(remainingTime);
        const additionalMinutes = Math.round(
          (remainingTime - additionalHours) * 60
        );

        deliveryHour += additionalHours;
        deliveryMinute += additionalMinutes;

        // Xử lý phút tràn
        if (deliveryMinute >= 60) {
          deliveryHour += Math.floor(deliveryMinute / 60);
          deliveryMinute = deliveryMinute % 60;
        }
      } else {
        // Vượt sang ngày hôm sau hoặc nhiều ngày
        remainingTime -= remainingHoursToday;

        // Tính số ngày cần thêm
        const additionalDays = Math.floor(remainingTime / WORK_HOURS_PER_DAY);
        const remainingHoursLastDay = remainingTime % WORK_HOURS_PER_DAY;

        // Cộng thêm ngày
        deliveryDate.setDate(deliveryDate.getDate() + additionalDays + 1);

        // Tính giờ giao hàng ngày cuối cùng
        deliveryHour = WORK_START + Math.floor(remainingHoursLastDay);
        deliveryMinute = Math.round(
          (remainingHoursLastDay - Math.floor(remainingHoursLastDay)) * 60
        );

        // Xử lý phút tràn
        if (deliveryMinute >= 60) {
          deliveryHour += Math.floor(deliveryMinute / 60);
          deliveryMinute = deliveryMinute % 60;
        }
      }

      // Set giờ và phút cho deliveryDate
      deliveryDate.setHours(deliveryHour, deliveryMinute, 0, 0);

      // Format giờ phút HH:MM
      const deliveryTimeStr = `${deliveryHour
        .toString()
        .padStart(2, "0")}:${deliveryMinute.toString().padStart(2, "0")}`;

      form.setFieldValue("timeDeliveryTime", deliveryTimeStr);

      // Kiểm tra nếu khác ngày hiện tại, cập nhật field deliveryAppointmentTime
      const isSameDay =
        deliveryDate.getDate() === now.getDate() &&
        deliveryDate.getMonth() === now.getMonth() &&
        deliveryDate.getFullYear() === now.getFullYear();

      // Nếu khác ngày, cập nhật cả field ngày giao hàng
      // @ts-ignore - Form type là string nhưng DateInput nhận Date object
      if (!isSameDay) {
        form.setFieldValue("deliveryAppointmentTime", deliveryDate as any);
      }
    }
    setShippingVendor(partner.name);

    // ⭐ Đóng modal sau một chút để đảm bảo state được update
    // React batching có thể gây ra vấn đề nếu đóng ngay lập tức
    setTimeout(() => {
      setOpenShippingPartnerModal(false);
    }, 100);
  };

  // Shipping partner limitations configuration
  const SHIPPING_LIMITATIONS = {
    "Siêu tốc": {
      maxWeight: 30, // kg
      maxDimension: 60, // cm
      name: "Ahamove Siêu tốc",
    },
    "Siêu tốc tiết kiệm": {
      maxWeight: 30, // kg
      maxDimension: 60, // cm
      name: "Ahamove Siêu tốc tiết kiệm",
    },
    GHTK: {
      maxWeight: 20, // kg
      maxDimension: 60, // cm
      name: "Giao hàng tiết kiệm",
    },
  } as const;

  // Function to check if a shipping partner is disabled based on conditions
  const isShippingPartnerDisabled = (partner: ShippingPartner) => {
    // Check if partner has API error (e.g., from Ahamove)
    if (partner.isDisabled || partner.errorMessage) {
      return true;
    }

    // Business rule: If isHaveVat = true and COD >= 5,000,000, disable all third-party shipping partners
    if (isHaveVat && cod && cod >= 5000000) {
      // Only allow internal Hacom partners (Nội bộ Hacom)
      if (
        partner.name === "Giao hàng tiết kiệm" ||
        partner.name === "Ahamove"
      ) {
        return true;
      }
    }

    if (!specificationsResult) return false;

    const totalWeight = specificationsResult.totalWeight;
    const maxDimension = specificationsResult.maxDimension; // in mm

    // Check GHTK limitations
    if (partner.name === "Giao hàng tiết kiệm") {
      // Business rule: Only check 50 million VND limit for COD orders
      const orderTotal = cod || 0;
      const isOrderTooLarge =
        payType === "Giao Hàng Thu Tiền(COD)" && orderTotal >= 50000000;

      return isOrderTooLarge;
    }

    // Check Ahamove limitations
    if (partner.name === "Ahamove") {
      const limits =
        SHIPPING_LIMITATIONS[
        partner.description as keyof typeof SHIPPING_LIMITATIONS
        ];
      if (!limits) return false;

      return (
        totalWeight > limits.maxWeight ||
        maxDimension > limits.maxDimension * 10 // limits in cm, maxDimension in mm
      );
    }

    return false; // Internal Hacom partners are never disabled
  };
  // Function to get disable reason for a shipping partner
  const getDisableReason = (partner: ShippingPartner) => {
    // Check if partner has API error message
    if (partner.errorMessage) {
      return partner.errorMessage;
    }

    // Business rule: If isHaveVat = true and COD >= 5,000,000, show reason for third-party partners
    if (isHaveVat && cod && cod >= 5000000) {
      if (
        partner.name === "Giao hàng tiết kiệm" ||
        partner.name === "Ahamove"
      ) {
        return "Đơn hàng có VAT và COD từ 5 triệu trở lên chỉ được giao bằng đội ngũ nội bộ";
      }
    }

    if (!specificationsResult) return "";

    const totalWeight = specificationsResult.totalWeight;
    const maxDimension = specificationsResult.maxDimension; // in mm
    // Check GHTK limitations
    if (partner.name === "Giao hàng tiết kiệm") {
      const reasons = [];
      // Business rule: Only check order total limit for COD orders
      const orderTotal = cod || 0;

      if (payType === "Giao Hàng Thu Tiền(COD)" && orderTotal >= 50000000)
        reasons.push(`Giá trị đơn hàng vượt quá 50 triệu đồng`);

      return reasons.join(" và ");
    }

    // Check Ahamove limitations
    if (partner.name === "Ahamove") {
      const limits =
        SHIPPING_LIMITATIONS[
        partner.description as keyof typeof SHIPPING_LIMITATIONS
        ];
      if (!limits) return "";

      const reasons = [];

      if (totalWeight > limits.maxWeight)
        reasons.push(`Trọng lượng vượt quá ${limits.maxWeight}kg`);
      if (maxDimension > limits.maxDimension * 10)
        // limits in cm, maxDimension in mm
        reasons.push(
          `Kích thước vượt quá ${limits.maxDimension}cm (${limits.maxDimension * 10
          }mm)`
        );

      return reasons.join(" và ");
    }

    return "";
  }; // Function to filter shipping partners based on location and time
  const getFilteredShippingPartners = () => {
    const currentProvinceId = form.values.customerProvinceId?.toString();

    // ⭐ CHỈ HỖ TRỢ GHTK VÀ AHAMOVE CHO HÀ NỘI VÀ HCM
    // Tìm tên tỉnh từ danh sách province thay vì dùng ID cứng
    const currentProvince = dataTblProvinceSelect.find(
      (p) => p.value.toString() === currentProvinceId
    );
    const provinceName = (currentProvince?.label || "").toLowerCase();

    // Kiểm tra tên tỉnh thay vì ID để tránh khác biệt giữa dev và prod
    // Chuyển về lowercase để không phân biệt chữ hoa/thường
    const isHanoiOrHCM =
      provinceName.includes("hà nội") ||
      provinceName.includes("ha noi") ||
      provinceName.includes("hồ chí minh") ||
      provinceName.includes("ho chi minh") ||
      provinceName.includes("tp.hcm") ||
      provinceName.includes("tp hồ chí minh") ||
      provinceName.includes("tp ho chi minh");

    // Define warehouse list that supports Ahamove and GHTK
    const dataWarehouse = [
      {
        id: 488,
        pick_address: "Số 131 Lê Thanh Nghị , Đồng Tâm , Hai Bà Trưng , Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Hai Bà Trưng",
        pick_ward: "Đồng Tâm",
        pick_tel: "0988655130",
      },
      {
        id: 489,
        pick_address: "Số 284 Thái Hà ,Trung Liệt, Đống Đa , Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Đống Đa",
        pick_ward: "Trung Liệt",
        pick_tel: "0988655130",
      },
      {
        id: 491,
        pick_address: "Số 79 Nguyễn Văn Huyên , Quan Hoa , Cầu Giấy , Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Cầu Giấy",
        pick_ward: "Quan Hoa",
        pick_tel: "0988655130",
      },
      {
        id: 492,
        pick_address: "Số 313 Quang Trung ,Phú La, Hà Đông , Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Hà Đông",
        pick_ward: "Phú La",
        pick_tel: "0988655130",
      },
      {
        id: 494,
        pick_address: "Số 622 Nguyễn Văn Cừ ,Gia Thụy , Long Biên , Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Long Biên",
        pick_ward: "Gia Thụy",
        pick_tel: "0988655130",
      },
      {
        id: 496,
        pick_address: "62 Nguyễn Hữu Thọ, Hoàng Liệt, Hoàng Mai, Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Hoàng Mai",
        pick_ward: "Đại Kim",
        pick_tel: "0988655130",
      },
      {
        id: 221,
        pick_address: "Số 57 Trần Phú ,Văn Quán, Hà Đông , Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Hà Đông",
        pick_ward: "Văn Quán",
        pick_tel: "0988655130",
      },
      {
        id: 2701,
        pick_address: "Số 805 Giải Phóng ,Giáp Bát, Hoàng Mai , Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Hoàng Mai",
        pick_ward: "Giáp Bát",
        pick_tel: "0988655130",
      },
      {
        id: 2721,
        pick_address:
          "Số 43 Louis 8 , Hoàng Mai, Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Hoàng Mai",
        pick_ward: "Yên Sở",
        pick_tel: "0988655130",
      },
      {
        id: 493,
        pick_address: "Số 478 Cách Mạng Tháng Tám, Quận 3, Hồ Chí Minh",
        pick_province: "Thành phố Hồ Chí Minh",
        pick_district: "Quận 3",
        pick_ward: "Phường 11",
        pick_tel: "0931435431",
      },
      {
        id: 2781,
        pick_address: "34 Trần Não, Phường An Khánh, Hồ Chí Minh",
        pick_province: "Hồ Chí Minh",
        pick_district: "Thủ Đức",
        pick_ward: "Phường An Khánh",
        pick_tel: "0901391682",
      },
      {
        id: 2782,
        pick_address: "783 Phan Văn Trị, Phường Hạnh Thông, Hồ Chí Minh",
        pick_province: "Hồ Chí Minh",
        pick_district: "Quận Gò Vấp",
        pick_ward: "Phường 1",
        pick_tel: "0908971358",
      },
      {
        id: 2741,
        pick_address: "Số 87 Trần Duy Hưng - Yên Hoà - Hà Nội",
        pick_province: "Hà Nội",
        pick_district: "Cầu Giấy",
        pick_ward: "Yên Hoà",
        pick_tel: "0988655130",
      },
    ];

    // Define warehouse list that supports only GHTK (không hỗ trợ Ahamove)
    // Đã cho phép 3 chi nhánh HCM (493, 2781, 2782) sử dụng Ahamove
    const ghtkOnlyWarehouses: number[] = []; // Tạm thời không có chi nhánh nào bị hạn chế Ahamove

    // Check if current branchId is in the supported warehouse list
    const isSupportedWarehouse = dataWarehouse.some(
      (warehouse) => warehouse.id === branchId
    );

    // Check if current branchId only supports GHTK (không hỗ trợ Ahamove)
    const isGhtkOnlyWarehouse = ghtkOnlyWarehouses.includes(branchId || 0);

    // Check if province is Hanoi (ID = 1) - without district filtering since we removed district level
    const isHanoiInternalDistrict = currentProvinceId === "1";

    let filteredPartners;
    if (
      isHanoiInternalDistrict &&
      isSupportedWarehouse &&
      !isGhtkOnlyWarehouse
    ) {
      // Show all partners, but mark internal ones as not recommended (chỉ áp dụng cho warehouse Hà Nội)
      filteredPartners = shippingPartners.map((partner) => ({
        ...partner,
        isNotRecommended:
          partner.name !== "Giao hàng tiết kiệm" && partner.name !== "Ahamove",
      }));
    } else if (isSupportedWarehouse && !isGhtkOnlyWarehouse) {
      // Show all partners for supported warehouses (Hà Nội) outside internal districts
      filteredPartners = shippingPartners.map((partner) => ({
        ...partner,
        isNotRecommended: false,
      }));
    } else if (isSupportedWarehouse && isGhtkOnlyWarehouse) {
      // Show internal Hacom partners + GHTK only (không hiển thị Ahamove cho warehouse HCM)
      filteredPartners = shippingPartners
        .filter((partner) => partner.name !== "Ahamove")
        .map((partner) => ({
          ...partner,
          isNotRecommended: false,
        }));
    } else {
      // Show only internal Hacom partners for non-supported warehouses
      filteredPartners = shippingPartners
        .filter(
          (partner) =>
            partner.name !== "Giao hàng tiết kiệm" && partner.name !== "Ahamove"
        )
        .map((partner) => ({
          ...partner,
          isNotRecommended: false,
        }));
    }

    // ⭐ NẾU TỈNH KHÔNG PHẢI HÀ NỘI HOẶC HCM → ẨN GHTK VÀ AHAMOVE
    if (!isHanoiOrHCM) {
      filteredPartners = filteredPartners.filter(
        (partner) =>
          partner.name !== "Giao hàng tiết kiệm" && partner.name !== "Ahamove"
      );
    }

    // Chỉ hiển thị GHTK khi loại vận chuyển là Xfast.
    if (!isGhtkExpressType) {
      filteredPartners = filteredPartners.filter(
        (partner) => partner.name !== "Giao hàng tiết kiệm"
      );
    }

    // Apply time filter if selected
    if (timeFilter) {
      filteredPartners = filteredPartners.filter((partner) => {
        if (timeFilter === "khac") {
          // Filter for "other" - partners with time > 8 hours or empty time
          return (
            !partner.estimatedTimeNumber || partner.estimatedTimeNumber > 8
          );
        } else {
          // Filter for specific hour value
          const selectedHours = parseInt(timeFilter);
          return partner.estimatedTimeNumber === selectedHours;
        }
      });
    }

    // Sort partners: Available ones first, then disabled ones
    filteredPartners.sort((a, b) => {
      const aDisabled = isShippingPartnerDisabled(a);
      const bDisabled = isShippingPartnerDisabled(b);

      // If one is disabled and other is not, prioritize the enabled one
      if (aDisabled && !bDisabled) return 1;
      if (!aDisabled && bDisabled) return -1;

      // If both have same availability status, maintain original order
      return 0;
    });

    return filteredPartners;
  };
  // Function to get partner limitations
  const getPartnerLimitations = (partner: ShippingPartner) => {
    // Check for external shipping partners with known limitations
    if (partner.name === "Giao hàng tiết kiệm") {
      return {
        maxWeight: 20,
        maxDimension: 60,
        hasLimitation: true,
      };
    }

    if (partner.name === "Ahamove") {
      // Check based on description
      if (partner.description === "Siêu tốc") {
        return {
          maxWeight: 30,
          maxDimension: 60,
          hasLimitation: true,
        };
      } else if (partner.description === "Siêu tốc tiết kiệm") {
        return {
          maxWeight: 30,
          maxDimension: 60,
          hasLimitation: true,
        };
      } else if (partner.description === "Đồng giá 25k") {
        return {
          maxWeight: 30,
          maxDimension: 60,
          hasLimitation: true,
        };
      }
    }

    // For internal Hacom partners, return no specific limitations
    return {
      maxWeight: null,
      maxDimension: null,
      hasLimitation: false,
    };
  };

  // Function to check if COD exceeds partner's limit
  // Only check when payment type is "Giao Hàng Thu Tiền(COD)"
  const isCodExceedLimit = (partner: ShippingPartner) => {
    // Only check COD limit for COD orders
    if (payType !== "Giao Hàng Thu Tiền(COD)") {
      return { exceeded: false, message: "" };
    }

    const codLimit = getPartnerCodLimit(partner);
    if (codLimit !== null && typeof cod === "number" && cod > codLimit) {
      return {
        exceeded: true,
        message: `Số tiền thu hộ (COD) vượt quá giới hạn cho đối tác này.\nGiới hạn: ${codLimit.toLocaleString()} đ. Vui lòng chọn đối tác khác hoặc giảm số tiền COD.`,
      };
    }
    return { exceeded: false, message: "" };
  };

  return (
    <>
      <Modal
        opened={openShippingPartnerModal}
        onClose={() => {
          // Chỉ reset shippingVendor nếu chưa có giá trị trước đó
          if (!form.values.shippingVendor) {
            form.setFieldValue("shippingVendor", "");
            form.setFieldValue("typeShip", "");
            setShippingVendor("");
          }
          setOpenShippingPartnerModal(false);
        }}
        title={
          <Group gap="md" align="center" style={{ width: "100%" }}>
            <Avatar
              size="lg"
              color="blue"
              variant="gradient"
              gradient={{ from: "#2196f3", to: "#1976d2", deg: 45 }}
              style={{
                boxShadow: "0 6px 20px rgba(33, 150, 243, 0.4)",
                border: "3px solid white",
              }}
            >
              <IconTruck size={24} />
            </Avatar>
            <Box style={{ flex: 1 }}>
              <Text size="xl" fw={700} c="#1976d2" mb={4}>
                🚚 Chọn đối tác vận chuyển
              </Text>
            </Box>
            <Group gap="sm">
              <Badge
                variant="gradient"
                gradient={{ from: "#4caf50", to: "#2e7d32", deg: 45 }}
                size="lg"
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                  padding: "8px 16px",
                  borderRadius: "20px",
                  boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
                }}
                className="shipping-badge"
              >
                ⚡ Tự động tính phí
              </Badge>
            </Group>
          </Group>
        }
        size="75%"
        centered
        zIndex={1001}
        overlayProps={{
          backgroundOpacity: 0.6,
          blur: 3,
        }}
        styles={{
          header: {
            background: "linear-gradient(135deg, #f8faff 0%, #e3f2fd 100%)",
            borderBottom: "3px solid #1976d2",
            marginBottom: "1rem",
            padding: "1.2rem 2rem",
            borderRadius: "12px 12px 0 0",
            boxShadow: "0 2px 8px rgba(25, 118, 210, 0.1)",
          },
          body: {
            padding: "0 2rem 2rem 2rem",
            maxHeight: "80vh",
            overflow: "auto",
            backgroundColor: "#fafbff",
          },
          title: {
            width: "100%",
          },
          content: {
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
            border: "1px solid #e3f2fd",
          },
          close: {
            color: "#000000",
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            borderRadius: "50%",
            width: "36px",
            height: "36px",
            fontSize: "20px",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.2)",
              color: "#000000",
            },
          },
        }}
        closeOnClickOutside={false}
        closeOnEscape={false}
      >
        {" "}
        {/* Display product information including distance and specifications */}
        {(calculatedDistance !== null || specificationsResult) && (
          <Box
            mb="lg"
            p="md"
            style={{
              background: specificationsResult?.hasOverSizeItems
                ? "linear-gradient(135deg, #ffe0b2 0%, #ffcc80 100%)"
                : "linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)",
              borderRadius: "12px",
              border: specificationsResult?.hasOverSizeItems
                ? "2px solid #ff9800"
                : "2px solid #4caf50",
              boxShadow: specificationsResult?.hasOverSizeItems
                ? "0 6px 20px rgba(255, 152, 0, 0.2)"
                : "0 6px 20px rgba(76, 175, 80, 0.2)",
            }}
          >
            <Group gap="md" align="flex-start">
              <Box style={{ flex: 1 }}>
                <Group gap="xs" mb="sm">
                  <Text
                    size="md"
                    fw={600}
                    c={
                      specificationsResult?.hasOverSizeItems
                        ? "#e65100"
                        : "#2e7d32"
                    }
                  >
                    📦 Thông tin đơn hàng
                  </Text>
                  {specificationsResult?.hasOverSizeItems && (
                    <Badge color="orange" variant="filled" size="sm">
                      ⚠️ Cảnh báo
                    </Badge>
                  )}{" "}
                  <Popover
                    position="top"
                    withArrow
                    shadow="lg"
                    opened={conditionsPopupOpened}
                    onChange={setConditionsPopupOpened}
                    width="500"
                    zIndex={1002}
                    styles={{
                      dropdown: {
                        background:
                          "linear-gradient(135deg, #f8faff 0%, #e3f2fd 100%)",
                        border: "2px solid #1976d2",
                        borderRadius: "12px",
                        padding: "0",
                        overflow: "hidden",
                        zIndex: 1002,
                      },
                    }}
                  >
                    <Popover.Target>
                      <Button
                        variant="light"
                        color="blue"
                        size="xs"
                        leftSection={<IconInfoCircle size={14} />}
                        onMouseEnter={() => setConditionsPopupOpened(true)}
                        onMouseLeave={() => setConditionsPopupOpened(false)}
                        style={{
                          fontSize: "11px",
                          fontWeight: 500,
                          padding: "4px 12px",
                        }}
                      >
                        Điều kiện đối tác
                      </Button>
                    </Popover.Target>
                    <Popover.Dropdown
                      onMouseEnter={() => setConditionsPopupOpened(true)}
                      onMouseLeave={() => setConditionsPopupOpened(false)}
                    >
                      <Box p="md">
                        <Text
                          size="sm"
                          fw={600}
                          mb="md"
                          c="#1976d2"
                          style={{
                            textAlign: "center",
                            fontSize: "16px",
                          }}
                        >
                          📋 Điều kiện đối tác vận chuyển
                        </Text>
                        <Text
                          size="xs"
                          c="dimmed"
                          mb="md"
                          style={{ fontStyle: "italic", textAlign: "center" }}
                        >
                          💡 Các điều kiện giới hạn của từng đối tác vận chuyển
                        </Text>{" "}
                        <Table
                          striped
                          highlightOnHover
                          withTableBorder
                          withColumnBorders
                          styles={{
                            table: {
                              fontSize: "12px",
                              borderRadius: "6px",
                              overflow: "hidden",
                            },
                            th: {
                              background: "#1976d2",
                              color: "white",
                              fontWeight: 600,
                              textAlign: "center",
                              padding: "8px 6px",
                              fontSize: "11px",
                            },
                            td: {
                              padding: "8px 6px",
                              textAlign: "center",
                              verticalAlign: "middle",
                              fontSize: "11px",
                            },
                          }}
                        >
                          {" "}
                          <Table.Thead>
                            <Table.Tr>
                              <Table.Th>Đối tác</Table.Th>
                              <Table.Th>Max kg</Table.Th>
                              <Table.Th>Max cm</Table.Th>
                            </Table.Tr>
                          </Table.Thead>
                          <Table.Tbody>
                            {" "}
                            <Table.Tr>
                              <Table.Td>
                                <Group gap="xs" justify="center">
                                  <Avatar
                                    size="xs"
                                    color="blue"
                                    variant="light"
                                  >
                                    <IconTruck size={10} />
                                  </Avatar>
                                  <Text fw={500} size="xs">
                                    Ahamove Siêu tốc
                                  </Text>
                                </Group>
                              </Table.Td>
                              <Table.Td>
                                <Badge color="blue" variant="light" size="xs">
                                  30kg
                                </Badge>
                              </Table.Td>
                              <Table.Td>
                                <Badge color="blue" variant="light" size="xs">
                                  60cm
                                </Badge>
                              </Table.Td>
                            </Table.Tr>
                            <Table.Tr>
                              <Table.Td>
                                <Group gap="xs" justify="center">
                                  <Avatar
                                    size="xs"
                                    color="green"
                                    variant="light"
                                  >
                                    <IconTruck size={10} />
                                  </Avatar>
                                  <Text fw={500} size="xs">
                                    Ahamove Tiết kiệm
                                  </Text>
                                </Group>
                              </Table.Td>
                              <Table.Td>
                                <Badge color="green" variant="light" size="xs">
                                  30kg
                                </Badge>
                              </Table.Td>
                              <Table.Td>
                                <Badge color="green" variant="light" size="xs">
                                  60cm
                                </Badge>
                              </Table.Td>
                            </Table.Tr>
                            <Table.Tr>
                              <Table.Td>
                                <Group gap="xs" justify="center">
                                  <Avatar
                                    size="xs"
                                    color="orange"
                                    variant="light"
                                  >
                                    <IconTruck size={10} />
                                  </Avatar>
                                  <Text fw={500} size="xs">
                                    Ahamove Đồng giá
                                  </Text>
                                </Group>
                              </Table.Td>
                              <Table.Td>
                                <Badge color="orange" variant="light" size="xs">
                                  30kg
                                </Badge>
                              </Table.Td>
                              <Table.Td>
                                <Badge color="orange" variant="light" size="xs">
                                  60cm
                                </Badge>
                              </Table.Td>
                            </Table.Tr>
                            <Table.Tr>
                              <Table.Td>
                                <Group gap="xs" justify="center">
                                  <Avatar
                                    size="xs"
                                    color="teal"
                                    variant="light"
                                  >
                                    <IconTruck size={10} />
                                  </Avatar>
                                  <Text fw={500} size="xs">
                                    GHTK
                                  </Text>
                                </Group>
                              </Table.Td>
                              <Table.Td>
                                <Badge color="teal" variant="light" size="xs">
                                  20kg
                                </Badge>
                              </Table.Td>
                              <Table.Td>
                                <Badge color="teal" variant="light" size="xs">
                                  60cm
                                </Badge>
                              </Table.Td>
                            </Table.Tr>
                          </Table.Tbody>
                        </Table>
                        <Box
                          mt="sm"
                          p="sm"
                          style={{
                            background:
                              "linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)",
                            borderRadius: "6px",
                            border: "1px solid #ff9800",
                          }}
                        >
                          <Text size="xs" fw={500} c="#e65100" mb="xs">
                            ⚠️ Lưu ý:
                          </Text>{" "}
                          <Text size="xs" c="dimmed" lh={1.4}>
                            • Đối tác bị <strong>vô hiệu hóa</strong> nếu vượt
                            điều kiện
                            <br />
                            • Nội bộ Hacom không bị giới hạn
                            <br />• Tất cả đối tác đều giới hạn 60cm kích thước
                          </Text>
                        </Box>
                      </Box>
                    </Popover.Dropdown>
                  </Popover>{" "}
                </Group>{" "}
                <Group
                  gap="lg"
                  wrap="wrap"
                  mb="md"
                  justify="space-between"
                  align="flex-start"
                >
                  {/* Left side: Order information */}
                  <Group gap="lg" wrap="wrap">
                    {calculatedDistance !== null && (
                      <Box>
                        <Text size="sm" c="dimmed" mb={2} fw={500}>
                          Khoảng cách giao hàng
                        </Text>
                        <Badge
                          variant="gradient"
                          gradient={{ from: "#1976d2", to: "#1565c0", deg: 45 }}
                          size="lg"
                          style={{
                            fontSize: "14px",
                            fontWeight: 600,
                            padding: "10px 16px",
                          }}
                        >
                          🛣️ {calculatedDistance} km
                        </Badge>
                      </Box>
                    )}
                    {isOffice124 && (
                      <Box>
                        <Text size="sm" c="dimmed" mb={2} fw={500}>
                          Điểm lấy hàng
                        </Text>
                        <Badge
                          variant="light"
                          color="indigo"
                          size="lg"
                          style={{
                            fontSize: "13px",
                            fontWeight: 600,
                            padding: "10px 16px",
                          }}
                        >
                          🏢 124 Minh Khai, Hai Bà Trưng, Hà Nội {senderPhone ? `(${senderPhone})` : ""}
                        </Badge>
                      </Box>
                    )}
                    {specificationsResult && (
                      <>
                        {(() => {
                          // TẠM ĐÓNG LOGIC CŨ: Không kiểm tra giới hạn cân nặng/kích thước cứng nữa
                          // const exceedsShippingLimits =
                          //   specificationsResult.totalWeight >
                          //   SHIPPING_LIMITATIONS.GHTK.maxWeight ||
                          //   specificationsResult.maxDimension >
                          //   SHIPPING_LIMITATIONS.GHTK.maxDimension * 10;
                          // const shouldShowBulkyWarning =
                          //   specificationsResult.hasOverSizeItems ||
                          //   exceedsShippingLimits;

                          // LOGIC MỚI: Dựa hoàn toàn vào cờ isCongKenh từ API trả về (được map vào hasOverSizeItems)
                          const shouldShowBulkyWarning = specificationsResult.hasOverSizeItems;

                          return (
                            <>
                              <Box>
                                <Text size="sm" c="dimmed" mb={2} fw={500}>
                                  Tổng trọng lượng
                                </Text>
                                <Badge
                                  variant="light"
                                  color={
                                    specificationsResult.totalWeight > 100
                                      ? "orange"
                                      : "blue"
                                  }
                                  size="lg"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    padding: "10px 16px",
                                  }}
                                >
                                  ⚖️ {specificationsResult.totalWeight.toFixed(2)} kg
                                </Badge>
                              </Box>

                              <Box>
                                <Text size="sm" c="dimmed" mb={2} fw={500}>
                                  Kích thước lớn nhất
                                </Text>
                                <Group gap="xs" wrap="wrap">
                                  <Badge
                                    variant="light"
                                    color={
                                      specificationsResult.maxDimension > 200
                                        ? "orange"
                                        : "green"
                                    }
                                    size="lg"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      padding: "10px 16px",
                                    }}
                                  >
                                    📏 {Math.round(specificationsResult.maxDimension)}{" "}
                                    mm
                                  </Badge>
                                  {shouldShowBulkyWarning && (
                                    <Badge
                                      variant="filled"
                                      color="orange"
                                      size="sm"
                                    >
                                      ⚠️ Hàng cồng kềnh
                                    </Badge>
                                  )}
                                </Group>
                              </Box>

                              {specificationsResult.hasOverSizeItems && (
                                <Box>
                                  <Text size="sm" c="dimmed" mb={2} fw={500}>
                                    Sản phẩm quá khổ
                                  </Text>
                                  <Badge
                                    variant="filled"
                                    color="orange"
                                    size="lg"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: 600,
                                      padding: "10px 16px",
                                    }}
                                  >
                                    ⚠️{" "}
                                    {specificationsResult.overSizeItemsDetails.length}{" "}
                                    sản phẩm
                                  </Badge>
                                </Box>
                              )}
                            </>
                          );
                        })()}
                      </>
                    )}
                  </Group>

                  {/* Right side: Time Filter */}
                  <Box style={{ minWidth: "240px" }}>
                    <Select
                      label="🕐 Lọc theo thời gian dự kiến"
                      placeholder="Chọn thời gian giao hàng"
                      value={timeFilter}
                      onChange={setTimeFilter}
                      data={[
                        { value: "1", label: "1 giờ" },
                        { value: "2", label: "2 giờ" },
                        { value: "3", label: "3 giờ" },
                        { value: "4", label: "4 giờ" },
                        { value: "5", label: "5 giờ" },
                        { value: "6", label: "6 giờ" },
                        {
                          value: "khac",
                          label: "Khác (>6h hoặc không xác định)",
                        },
                      ]}
                      clearable
                      size="sm"
                      comboboxProps={{
                        zIndex: 1003,
                        position: "bottom-start",
                      }}
                      styles={{
                        input: {
                          borderRadius: "6px",
                          border: "1px solid #d1e3ff",
                          "&:focus": {
                            borderColor: "#1976d2",
                          },
                        },
                        label: {
                          fontWeight: 500,
                          color: "#1976d2",
                          marginBottom: "4px",
                          fontSize: "13px",
                        },
                        dropdown: {
                          zIndex: 1003,
                        },
                      }}
                    />

                    {timeFilter && (
                      <Group gap="xs" mt="xs" justify="space-between">
                        <Badge
                          variant="gradient"
                          gradient={{ from: "#1976d2", to: "#1565c0", deg: 45 }}
                          size="sm"
                          style={{
                            fontSize: "11px",
                            padding: "4px 8px",
                          }}
                        >
                          📊 {getFilteredShippingPartners().length} đối tác
                        </Badge>
                        <Text
                          size="xs"
                          c="dimmed"
                          style={{ fontStyle: "italic" }}
                        >
                          {timeFilter === "khac"
                            ? ">6h hoặc n/a"
                            : `${timeFilter}h`}
                        </Text>
                      </Group>
                    )}
                  </Box>
                </Group>{" "}
                {specificationsResult?.hasOverSizeItems && (
                  <Box
                    mt="sm"
                    p="sm"
                    style={{
                      background: "rgba(255, 255, 255, 0.3)",
                      borderRadius: "8px",
                      border: "1px solid rgba(255, 152, 0, 0.3)",
                    }}
                  >
                    <Text size="xs" c="dimmed" mb={4}>
                      Danh sách sản phẩm quá khổ:
                    </Text>
                    {specificationsResult.overSizeItemsDetails
                      .slice(0, 3)
                      .map((item, index) => (
                        <Box key={index} mb={2}>
                          <Text size="xs" fw={500} c="#e65100">
                            • {item.itemCode} - {item.itemName}
                          </Text>
                          <Text size="xs" c="dimmed" ml="md">
                            {item.weight}kg, {item.length}×{item.width}×
                            {item.height}mm
                          </Text>
                        </Box>
                      ))}
                    {specificationsResult.overSizeItemsDetails.length > 3 && (
                      <Text
                        size="xs"
                        c="dimmed"
                        style={{ fontStyle: "italic" }}
                      >
                        ... và{" "}
                        {specificationsResult.overSizeItemsDetails.length - 3}{" "}
                        sản phẩm khác
                      </Text>
                    )}{" "}
                  </Box>
                )}
                {specificationsResult?.hasOverSizeItems && (
                  <Text
                    size="xs"
                    c="#e65100"
                    mt="xs"
                    style={{ fontStyle: "italic" }}
                  >
                    💡 Lưu ý: Một số đối tác vận chuyển có thể từ chối hoặc tính
                    phí bổ sung cho hàng hóa quá khổ
                  </Text>
                )}{" "}
              </Box>
            </Group>
          </Box>
        )}{" "}
        {/* ⭐ Hiển thị loading khi đang tải phí */}
        {isShippingFeeLoading ? (
          <Box
            p="xl"
            style={{
              textAlign: "center",
              background: "linear-gradient(135deg, #f8faff 0%, #e3f2fd 100%)",
              borderRadius: "12px",
              border: "2px solid #1976d2",
              position: "relative",
              minHeight: "300px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              className="loading-shimmer"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "3px",
              }}
            />
            <Group justify="center" gap="lg">
              <Avatar
                size="xl"
                color="blue"
                variant="gradient"
                gradient={{ from: "#2196f3", to: "#1976d2", deg: 45 }}
                style={{
                  animation: "pulse 2s infinite",
                  boxShadow: "0 6px 20px rgba(33, 150, 243, 0.4)",
                }}
              >
                <IconTruck size={32} />
              </Avatar>
              <Box>
                <Text size="xl" fw={700} c="#1976d2" mb="sm">
                  {loadingTitleText}
                </Text>
                <Text size="lg" c="blue" fw={500}>
                  {loadingDetailText}
                </Text>
                <Text
                  size="sm"
                  c="dimmed"
                  mt="xs"
                  style={{ fontStyle: "italic" }}
                >
                  ✨ Vui lòng đợi trong giây lát...
                </Text>
              </Box>
            </Group>
          </Box>
        ) : (
          <Table
            striped
            highlightOnHover
            withTableBorder
            withColumnBorders
            className="shipping-modal-table"
            styles={{
              table: {
                fontSize: "15px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
                background: "linear-gradient(135deg, #ffffff 0%, #f8faff 100%)",
                border: "1px solid #e3f2fd",
              },
              th: {
                background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                color: "white",
                fontWeight: 700,
                fontSize: "15px",
                padding: "16px 12px",
                textAlign: "center",
                borderBottom: "3px solid #1565c0",
                textShadow: "0 1px 2px rgba(0, 0, 0, 0.2)",
                position: "relative",
              },
              td: {
                padding: "16px 12px",
                fontSize: "14px",
                verticalAlign: "middle",
                borderBottom: "1px solid #e8f4fd",
                transition: "all 0.2s ease",
              },
              tr: {
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              },
            }}
          >
            {" "}
            <Table.Thead>
              <Table.Tr>
                <Table.Th style={{ width: "30%" }}>
                  <Group gap="xs" justify="center">
                    <IconTruck size={18} color="white" />
                    <Text size="sm" fw={700} c="white">
                      Tên đơn vị vận chuyển
                    </Text>
                  </Group>
                </Table.Th>
                <Table.Th style={{ width: "15%" }}>
                  <Group gap="xs" justify="center">
                    <Text size="lg">💰</Text>
                    <Text size="sm" fw={700} c="white">
                      Phí vận chuyển
                    </Text>
                  </Group>
                </Table.Th>
                <Table.Th style={{ width: "10%" }}>
                  <Group gap="xs" justify="center">
                    <Text size="lg">⚡</Text>
                    <Text size="sm" fw={700} c="white">
                      Loại vận chuyển
                    </Text>
                  </Group>
                </Table.Th>
                <Table.Th style={{ width: "15%" }}>
                  <Group gap="xs" justify="center">
                    <IconClock size={18} color="white" />
                    <Text size="sm" fw={700} c="white">
                      Thời gian dự kiến
                    </Text>
                  </Group>
                </Table.Th>
                <Table.Th style={{ width: "20%" }}>
                  <Group gap="xs" justify="center">
                    <Text size="lg">📏</Text>
                    <Text size="sm" fw={700} c="white">
                      Giới hạn
                    </Text>
                  </Group>
                </Table.Th>
                <Table.Th style={{ width: "10%" }}>
                  <Group gap="xs" justify="center">
                    <IconCheck size={18} color="white" />
                    <Text size="sm" fw={700} c="white">
                      Thao tác
                    </Text>
                  </Group>
                </Table.Th>
              </Table.Tr>
            </Table.Thead>{" "}
            <Table.Tbody>
              {" "}
              {getFilteredShippingPartners()
                // .filter((i) => i.name !== "Ahamove")
                .map((partner, index) => {
                  // Hiển thị phí của từng đối tác
                  const displayFee = partner.fee;
                  const codCheck = isCodExceedLimit(partner);
                  // Variable removed

                  // Disable if: partner is disabled, has error message, or COD exceeds limit
                  // Note: cod = 0 is valid for non-COD orders (paid in advance)
                  const disabled =
                    isShippingPartnerDisabled(partner) ||
                    codCheck.exceeded ||
                    !!partner.errorMessage;
                  let disableReason = "";
                  if (codCheck.exceeded) {
                    disableReason = codCheck.message;
                  } else if (partner.errorMessage) {
                    disableReason = partner.errorMessage;
                  } else if (isShippingPartnerDisabled(partner)) {
                    disableReason = getDisableReason(partner);
                  }
                  return (
                    <Table.Tr
                      key={`${partner.id}-${index}`}
                      className="shipping-row"
                      style={{
                        backgroundColor: partner.isNotRecommended
                          ? "#ffebee"
                          : index % 2 === 0
                            ? "#f8faff"
                            : "white",
                        cursor: "pointer",
                        borderLeft: partner.isNotRecommended
                          ? "4px solid #ff5722"
                          : "4px solid transparent",
                      }}
                      onMouseEnter={(e) => {
                        if (!partner.isNotRecommended) {
                          e.currentTarget.style.backgroundColor = "#e3f2fd";
                          e.currentTarget.style.borderLeft =
                            "4px solid #1976d2";
                        }
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor =
                          partner.isNotRecommended
                            ? "#ffebee"
                            : index % 2 === 0
                              ? "#f8faff"
                              : "white";
                        e.currentTarget.style.borderLeft =
                          partner.isNotRecommended
                            ? "4px solid #ff5722"
                            : "4px solid transparent";
                      }}
                    >
                      <Table.Td>
                        <Group gap="sm" align="center">
                          <Avatar
                            size="sm"
                            color={partner.isNotRecommended ? "red" : "blue"}
                            variant="light"
                          >
                            <IconTruck size={16} />
                          </Avatar>
                          <Box style={{ flex: 1 }}>
                            <Group gap="xs" align="center">
                              <Text
                                fw={500}
                                size="sm"
                                c={partner.isNotRecommended ? "red" : undefined}
                              >
                                {partner.name === "COD" ? "Kho đóng gói" : partner.name}
                              </Text>
                              {partner.isNotRecommended && (
                                <Badge color="red" size="xs" variant="light">
                                  Không khuyến khích
                                </Badge>
                              )}
                            </Group>
                            <Text size="xs" c="dimmed">
                              {partner.description}
                            </Text>
                          </Box>
                        </Group>
                      </Table.Td>{" "}
                      <Table.Td style={{ textAlign: "center" }}>
                        {/* Check if partner has error message from API */}
                        {partner.errorMessage ? (
                          <Badge
                            variant="filled"
                            color="red"
                            size="sm"
                            title={partner.errorMessage}
                            style={{
                              maxWidth: "150px",
                              textOverflow: "ellipsis",
                              overflow: "hidden",
                            }}
                          >
                            ❌ {partner.errorMessage}
                          </Badge>
                        ) : (
                          <Badge
                            variant="filled"
                            color={
                              partner.isNotRecommended
                                ? "red"
                                : displayFee === 0
                                  ? "green"
                                  : "blue"
                            }
                            size="sm"
                          >
                            <NumberFormatter
                              value={displayFee}
                              thousandSeparator="."
                              decimalSeparator=","
                              suffix=" đ"
                            />
                          </Badge>
                        )}
                      </Table.Td>{" "}
                      <Table.Td style={{ textAlign: "center" }}>
                        {(partner.name || "").toLowerCase().includes("ahamove") ? (
                          <Badge color="orange" variant="light" size="xs">
                            {partner.description || "Siêu tốc"}
                          </Badge>
                        ) : (partner.name || "").toLowerCase().includes("grab") ? (
                          <Badge color="green" variant="light" size="xs">
                            {partner.description || "GrabExpress"}
                          </Badge>
                        ) : ((partner.name || "")
                          .normalize("NFD")
                          .replace(/[\u0300-\u036f]/g, "")
                          .toLowerCase()
                          .trim() === "ghtk" ||
                          (partner.name || "")
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                            .toLowerCase()
                            .includes("giao hang tiet kiem")) ? (
                          partner.description === "Cồng Kềnh" ? (
                            <Badge color="red" variant="light" size="xs">
                              Cồng Kềnh
                            </Badge>
                          ) : isGhtkExpressType ? (
                            <Badge
                              color="orange"
                              variant="light"
                              size="xs"
                            >
                              Xfast
                            </Badge>
                          ) : (
                            <Text size="xs" c="dimmed">-</Text>
                          )
                        ) : (
                          <Text size="xs" c="dimmed">
                            -
                          </Text>
                        )}
                      </Table.Td>
                      <Table.Td style={{ textAlign: "center" }}>
                        <Group justify="center" gap="xs">
                          <IconClock
                            size={14}
                            color={partner.isNotRecommended ? "red" : "gray"}
                          />
                          <Text
                            size="sm"
                            c={partner.isNotRecommended ? "red" : undefined}
                          >
                            {partner.estimatedTime}
                          </Text>
                        </Group>
                      </Table.Td>
                      {/* New Limitations Column */}
                      <Table.Td style={{ textAlign: "center" }}>
                        {(() => {
                          const limitations = getPartnerLimitations(partner);
                          // Thêm logic hiển thị giới hạn COD tối đa
                          let codLimit = null;
                          if (partner.name === "Giao hàng tiết kiệm")
                            codLimit = 20000000;
                          if (
                            partner.name === "Ahamove" &&
                            partner.description === "Siêu tốc"
                          )
                            codLimit = 10000000;
                          if (
                            partner.name === "Ahamove" &&
                            partner.description === "Siêu tốc tiết kiệm"
                          )
                            codLimit = 10000000;
                          if (
                            partner.name === "Ahamove" &&
                            partner.description === "Đồng giá 25k"
                          )
                            codLimit = 1000000;
                          if (limitations.hasLimitation) {
                            return (
                              <Box>
                                <Group justify="center" gap={3} mb={2}>
                                  <Badge
                                    variant="light"
                                    color="blue"
                                    size="xs"
                                    style={{
                                      fontSize: "9px",
                                      padding: "2px 6px",
                                    }}
                                  >
                                    ⚖️ {limitations.maxWeight}kg
                                  </Badge>
                                </Group>
                                <Group justify="center" gap={3}>
                                  <Badge
                                    variant="light"
                                    color="green"
                                    size="xs"
                                    style={{
                                      fontSize: "9px",
                                      padding: "2px 6px",
                                    }}
                                  >
                                    📏 {limitations.maxDimension}cm
                                  </Badge>
                                </Group>
                                <Group justify="center" gap={3} mt={2}>
                                  <Badge
                                    variant="light"
                                    color={codLimit ? "red" : "gray"}
                                    size="xs"
                                    style={{
                                      fontSize: "9px",
                                      padding: "2px 6px",
                                    }}
                                  >
                                    {codLimit
                                      ? `💵 COD tối đa ${codLimit.toLocaleString()} đ`
                                      : "Không xác định COD"}
                                  </Badge>
                                </Group>
                              </Box>
                            );
                          } else {
                            return (
                              <Badge
                                variant="light"
                                color="gray"
                                size="xs"
                                style={{ fontSize: "10px" }}
                              >
                                Không xác định
                              </Badge>
                            );
                          }
                        })()}
                      </Table.Td>{" "}
                      <Table.Td style={{ textAlign: "center" }}>
                        {disabled ? (
                          <Tooltip
                            label={disableReason}
                            color="red"
                            withArrow
                            position="top"
                            multiline
                            maw={300}
                          >
                            <Button
                              size="xs"
                              variant="outline"
                              color="red"
                              disabled
                              style={{ pointerEvents: "auto" }}
                            >
                              Không khả dụng
                            </Button>
                          </Tooltip>
                        ) : (
                          <Button
                            size="xs"
                            variant={
                              partner.isNotRecommended ? "outline" : "filled"
                            }
                            color={partner.isNotRecommended ? "red" : "blue"}
                            onClick={() => handleSelectShippingPartner(partner)}
                          >
                            Chọn
                          </Button>
                        )}
                      </Table.Td>
                    </Table.Tr>
                  );
                })}
            </Table.Tbody>{" "}
          </Table>
        )}{" "}
      </Modal>
      <Box
        component="form"
        onSubmit={form.onSubmit(async (values) => await handleSaveForm(values))}
        style={{
          position: "relative",
        }}
      >
        <Grid
          mt={10}
          style={{
            pointerEvents: readOnly ? "none" : "auto",
          }}
        >
          <Grid.Col span={4}>
            <TextInput
              withAsterisk
              label={"Người nhận hàng"}
              placeholder={"Nhập tên"}
              defaultValue={customerCheck?.name}
              type="text"
              {...form.getInputProps("customerName")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <TextInput
              withAsterisk
              label={"Số điện thoại"}
              placeholder={"Nhập sđt"}
              defaultValue={customerCheck?.telephoneNumber}
              maxLength={11}
              type="number"
              {...form.getInputProps("telephoneNumber")}
            />
          </Grid.Col>
          <Grid.Col
            span={4}
            style={{
              display: "flex",
              alignItems: "flex-end",
              paddingBottom: "4px",
            }}
          >
            <Tooltip
              label="Copy tên người nhận & số điện thoại"
              withArrow
              position="top"
            >
              <Button
                variant="light"
                color="blue"
                onClick={handleCopyCustomerInfo}
                disabled={
                  !form.values.customerName && !form.values.telephoneNumber
                }
                leftSection={<IconCopy size={16} />}
                style={{ pointerEvents: "auto" }}
              >
                Copy
              </Button>
            </Tooltip>
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              withAsterisk
              label={"Tỉnh/Thành phố"}
              placeholder={"Chọn tỉnh/thành phố"}
              searchable
              data={dataTblProvinceSelect}
              nothingFoundMessage={"Không có dữ liệu"}
              {...form.getInputProps("customerProvinceId")}
              onChange={(e) => handleChangeSelectedProvince(e)}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <Select
              withAsterisk
              disabled={
                !form.values.customerProvinceId ||
                dataTblCommuneSelect.length === 0
              }
              label={"Phường/Xã"}
              placeholder={"Chọn Phường/Xã"}
              searchable
              data={dataTblCommuneSelect}
              nothingFoundMessage={"Không có dữ liệu"}
              {...form.getInputProps("customerCommuneId")}
              onChange={(e) => handleChangeSelectedCommune(e)}
            />
          </Grid.Col>
          <Grid.Col span={7}>
            {" "}
            <TextInput
              withAsterisk
              label={
                "Địa chỉ cụ thể (Không bao gồm tên Phường/Xã - Quận/Huyện - Tỉnh/Thành phố )"
              }
              placeholder={"Nhập địa chỉ"}
              type="text"
              {...form.getInputProps("customerAddress")}
            />{" "}
          </Grid.Col>
          <Grid.Col
            span={1}
            style={{
              display: "flex",
              alignItems: "flex-end",
              paddingBottom: "4px",
              pointerEvents: "auto",
            }}
          >
            <Tooltip label="Copy toàn bộ địa chỉ" withArrow position="top">
              <Button
                variant="light"
                color="blue"
                onClick={handleCopyAddress}
                disabled={
                  !form.values.customerProvinceId ||
                  !form.values.customerCommuneId ||
                  !form.values.customerAddress
                }
                leftSection={<IconCopy size={16} />}
                style={{ pointerEvents: "auto" }}
              >
                Copy
              </Button>
            </Tooltip>
          </Grid.Col>
          {/* Bỏ nút tính quãng đường - sẽ tự động tính khi mở popup */}
          <Grid.Col span={4}>
            {calculatedDistance !== null && (
              <Box
                style={{
                  color: "#1976d2",
                  fontWeight: 500,
                  fontSize: 13,
                  paddingTop: 32,
                }}
              >
                Khoảng cách: {calculatedDistance} km
              </Box>
            )}
          </Grid.Col>{" "}
          <Grid.Col span={4}>
            <DatePickerInput
              label={"Ngày nhận hàng dự kiến"}
              withAsterisk
              placeholder={"Nhập ngày"}
              valueFormat="DD/MM/YYYY"
              minDate={new Date()}
              {...form.getInputProps("deliveryAppointmentTime")}
              clearable
            />
          </Grid.Col>
          {renderShippingTypeAndTime()}
          <Grid.Col span={4}>
            <TextInput
              withAsterisk
              disabled
              label={"Đơn vị vận chuyển"}
              type="text"
              {...form.getInputProps("shippingVendor")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <NumberInput
              disabled
              min={0}
              value={0}
              label="COD"
              thousandSeparator=","
              hideControls
              onKeyDown={handleKeyDown}
              {...form.getInputProps("cod")}
            />
          </Grid.Col>
          <Grid.Col span={4}>
            <NumberInput
              disabled={isShippingFeeDisabled}
              min={0}
              label="Phí ship"
              placeholder="Nhập phí ship"
              thousandSeparator=","
              hideControls
              onKeyDown={handleKeyDown}
              value={displayDeliveryFee}
              onChange={(value) => {
                const newFee = Number(value) || 0;
                console.log("💰 Phí ship onChange:", {
                  newFee,
                  currentValue: displayDeliveryFee,
                });

                // Update cả display value và data
                setDisplayDeliveryFee(newFee);
                setDataDeliveryInformation({
                  ...dataDeliveryInformation,
                  deliveryFee: newFee,
                });

                // ⭐ CẬP NHẬT LUÔN VÀO orderHeader.attribute3
                if (setOrderHeader) {
                  setOrderHeader((prevOrderHeader: any) => ({
                    ...prevOrderHeader,
                    attribute3: newFee,
                  }));
                }
              }}
            />
          </Grid.Col>
          {/* <Grid.Col span={2}>
            <Checkbox
              style={{ marginTop: "20px" }}
              label={"Hàng dễ vỡ"}
              checked={form.getValues()?.status}
              key={"status"}
              {...form.getInputProps("status")}
            />
          </Grid.Col> */}
          {["NV điều vận", "Kỹ thuật", "Dự án", "Kỹ thuật thi công"].includes(
            shipingVendor || ""
          ) && (
              <>
                <Grid.Col span={8}>
                  <Select
                    withAsterisk
                    label={"Chọn nhà xe"}
                    placeholder={"Chọn nhà xe"}
                    searchable
                    clearable
                    data={dataStation}
                    nothingFoundMessage={"Không có dữ liệu"}
                    {...form.getInputProps("to_address_id")}
                    onChange={(e) => handleChangeStation(e)}
                  />
                </Grid.Col>
                <Grid.Col span={4}>
                  <NumberInput
                    disabled
                    min={0}
                    value={form.values.distance || 0}
                    label="Khoảng cách"
                    // thousandSeparator=","
                    hideControls
                    onKeyDown={handleKeyDown}
                    {...form.getInputProps("distance")}
                  />
                </Grid.Col>
              </>
            )}{" "}
          <Grid.Col span={12}>
            {!readOnly ? (
              <MultiSelect
                label="Ghi chú hàng hóa"
                placeholder="Chọn ghi chú hàng hóa"
                data={dataItemNote}
                value={
                  form.getValues()?.itemNotes &&
                    String(form.getValues()?.itemNotes).length > 0
                    ? form
                      .getValues()
                      ?.itemNotes?.split(",")
                      ?.map((i) => String(i))
                    : []
                }
                onChange={(e) =>
                  form.setValues((prev) => ({
                    ...prev,
                    itemNotes: e && e.length > 0 ? e.join(",") : null,
                    itemNotesName:
                      e && e.length > 0
                        ? dataItemNote
                          .filter((i: any) => e.includes(String(i.value)))
                          .map((i) => String(i.label))
                          .join(", ")
                        : null,
                  }))
                }
                searchable
                clearable
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                readOnly={readOnly}
              />
            ) : (
              <TextInput
                label="Ghi chú hàng hóa"
                placeholder="Ghi chú hàng hóa"
                value={form.getValues()?.itemNotesName || ""}
                readOnly={readOnly}
              />
            )}
          </Grid.Col>
          <Grid.Col span={8}>
            <TextInput
              label={"Ghi chú vận chuyển"}
              placeholder={"Nhập ghi chú vận chuyển"}
              type="text"
              {...form.getInputProps("description")}
            />
          </Grid.Col>{" "}
          <Grid.Col span={4}>
            <Box mt={24}>
              {" "}
              <Button
                variant="outline"
                color="blue"
                fullWidth
                onClick={handleOpenShippingPartnerModal}
                leftSection={<IconTruck size={16} />}
                disabled={
                  !form.values.customerName ||
                  !form.values.telephoneNumber ||
                  !form.values.customerProvinceId ||
                  !form.values.customerCommuneId ||
                  !form.values.customerAddress ||
                  (isOffice124 && !senderPhone?.trim()) ||
                  isPreparingShippingFee
                }
                loading={isPreparingShippingFee}
              >
                Chọn đối tác
              </Button>
              {form.values.shippingVendor && (
                <Box
                  mt="xs"
                  p="xs"
                  style={{ backgroundColor: "#f8f9fa", borderRadius: "4px" }}
                >
                  <Group gap="xs">
                    <Avatar size="xs" color="green" variant="light">
                      <IconCheck size={12} />
                    </Avatar>
                    <Box>
                      <Text size="sm" fw={500} c="green">
                        {form.values.shippingVendor}
                      </Text>
                      <Text size="xs" c="dimmed">
                        Đã chọn đối tác vận chuyển
                      </Text>
                    </Box>
                  </Group>
                </Box>
              )}
            </Box>
          </Grid.Col>
          <Grid.Col span={12}>
            <Box
              p="sm"
              style={{
                backgroundColor: isOffice124 ? "#f0f7ff" : "#f8f9fa",
                borderRadius: "8px",
                border: isOffice124 ? "1.5px solid #1976d2" : "1px dashed #ced4da",
                transition: "all 0.2s ease",
              }}
            >
              <Group justify="space-between" align="center" mb={isOffice124 ? "xs" : 0}>
                <Checkbox
                  label={
                    <Text fw={600} size="sm" c={isOffice124 ? "#1976d2" : "inherit"}>
                      Giao hàng cho văn phòng 124
                    </Text>
                  }
                  checked={isOffice124}
                  onChange={(event) => {
                    const checked = event.currentTarget.checked;
                    setIsOffice124(checked);
                    setCalculatedDistance(null);
                    setCachedDistanceKm(null);
                    if (!checked) {
                      setSenderPhoneError("");
                    }
                  }}
                  readOnly={readOnly}
                />
                {isOffice124 && (
                  <Badge color="blue" variant="light" size="sm">
                    Kho lấy hàng: Văn phòng 124
                  </Badge>
                )}
              </Group>

              {isOffice124 && (
                <Grid mt="xs" align="flex-start">
                  <Grid.Col span={6}>
                    <TextInput
                      withAsterisk
                      label="Số điện thoại người gửi đơn hàng"
                      placeholder="Nhập SĐT người gửi đơn hàng này"
                      value={senderPhone}
                      onChange={(e) => {
                        const val = e.currentTarget.value;
                        setSenderPhone(val);
                        if (val.trim()) {
                          setSenderPhoneError("");
                        }
                      }}
                      error={senderPhoneError}
                      readOnly={readOnly}
                    />
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Box
                      p="xs"
                      style={{
                        backgroundColor: "#ffffff",
                        borderRadius: "6px",
                        border: "1px solid #e3f2fd",
                        fontSize: "12px",
                      }}
                    >
                      <Text size="xs" fw={500} c="#1976d2" mb={4}>
                        📍 Thông tin lấy hàng áp dụng:
                      </Text>
                      <Text size="xs" c="dimmed">
                        • <strong>Địa chỉ lấy hàng:</strong> 124 Minh Khai, Hai Bà Trưng, Hà Nội
                      </Text>
                      <Text size="xs" c="dimmed">
                        • <strong>Số ĐT liên hệ lấy hàng:</strong> {senderPhone || "(Chờ nhập SĐT...)"}
                      </Text>
                    </Box>
                  </Grid.Col>
                </Grid>
              )}
            </Box>
          </Grid.Col>
        </Grid>
        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>{" "}
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
            style={{
              pointerEvents: readOnly ? "none" : "auto",
            }}
            disabled={!form.values.shippingVendor}
          >
            Lưu{" "}
          </Button>
        </Group>
      </Box>
    </>
  );
};

export default ModalDeliveryInformation;
